var items = {
  "block.minecraft.acacia_button": "Knopka z akacyi",
  "block.minecraft.acacia_door": "Dzviery z akacyi",
  "block.minecraft.acacia_fence": "Płot z akacyi",
  "block.minecraft.acacia_fence_gate": "Bramka z akacyi",
  "block.minecraft.acacia_hanging_sign": "Padviesnaja šylda z akacyi",
  "block.minecraft.acacia_leaves": "Liscie akacyi",
  "block.minecraft.acacia_log": "Bierviano z akacyi",
  "block.minecraft.acacia_planks": "Doški z akacyi",
  "block.minecraft.acacia_pressure_plate": "Nacisknaja plita z akacyi",
  "block.minecraft.acacia_sapling": "Sadžaniec akacyi",
  "block.minecraft.acacia_shelf": "Palica z akacyi",
  "block.minecraft.acacia_sign": "Šylda z akacyi",
  "block.minecraft.acacia_slab": "Plita z akacyi",
  "block.minecraft.acacia_stairs": "Prystupki z akacyi",
  "block.minecraft.acacia_trapdoor": "Luk z akacyi",
  "block.minecraft.acacia_wall_hanging_sign": "Nasciennaja padviesnaja šylda z akacyi",
  "block.minecraft.acacia_wall_sign": "Nasciennaja šylda z akacyi",
  "block.minecraft.acacia_wood": "Draŭnina akacyi",
  "block.minecraft.activator_rail": "Aktyvujučyja rejki",
  "block.minecraft.air": "Pavietra",
  "block.minecraft.allium": "Cybula",
  "block.minecraft.amethyst_block": "Amietystavy błok",
  "block.minecraft.amethyst_cluster": "Amietystavaja druza",
  "block.minecraft.ancient_debris": "Staražytnyja reštki",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Plita z andezitu",
  "block.minecraft.andesite_stairs": "Prystupki z andezitu",
  "block.minecraft.andesite_wall": "Sciana z andezitu",
  "block.minecraft.anvil": "Kavadła",
  "block.minecraft.attached_melon_stem": "Pryrosłaje sciabło kavuna",
  "block.minecraft.attached_pumpkin_stem": "Pryrosłaje sciabło harbuza",
  "block.minecraft.azalea": "Azalija",
  "block.minecraft.azalea_leaves": "Liscie azalii",
  "block.minecraft.azure_bluet": "Chaŭstonija błakitnaja",
  "block.minecraft.bamboo": "Bambuk",
  "block.minecraft.bamboo_block": "Bambukavy błok",
  "block.minecraft.bamboo_button": "Bambukavaja knopka",
  "block.minecraft.bamboo_door": "Bambukavyja dzviery",
  "block.minecraft.bamboo_fence": "Bambukavy płot",
  "block.minecraft.bamboo_fence_gate": "Bambukavaja bramka",
  "block.minecraft.bamboo_hanging_sign": "Bambukavaja padviesnaja šylda",
  "block.minecraft.bamboo_mosaic": "Bambukavaja mazaika",
  "block.minecraft.bamboo_mosaic_slab": "Plita z bambukavaj mazaiki",
  "block.minecraft.bamboo_mosaic_stairs": "Prystupki z bambukavaj mazaiki",
  "block.minecraft.bamboo_planks": "Bambukavyja doški",
  "block.minecraft.bamboo_pressure_plate": "Bambukavaja nacisknaja plita",
  "block.minecraft.bamboo_sapling": "Parastak bambuku",
  "block.minecraft.bamboo_shelf": "Bambukavaja palica",
  "block.minecraft.bamboo_sign": "Bambukavaja šylda",
  "block.minecraft.bamboo_slab": "Bambukavaja plita",
  "block.minecraft.bamboo_stairs": "Bambukavyja prystupki",
  "block.minecraft.bamboo_trapdoor": "Bambukavy luk",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambukavaja nasciennaja padviesnaja šylda",
  "block.minecraft.bamboo_wall_sign": "Bambukavaja nasciennaja šylda",
  "block.minecraft.banner.base.black": "Całkam čornaje pole",
  "block.minecraft.banner.base.blue": "Całkam siniaje pole",
  "block.minecraft.banner.base.brown": "Całkam karyčnievaje pole",
  "block.minecraft.banner.base.cyan": "Całkam biruzovaje pole",
  "block.minecraft.banner.base.gray": "Całkam šeraje pole",
  "block.minecraft.banner.base.green": "Całkam zialonaje pole",
  "block.minecraft.banner.base.light_blue": "Całkam błakitnaje pole",
  "block.minecraft.banner.base.light_gray": "Całkam svietła-šeraje pole",
  "block.minecraft.banner.base.lime": "Całkam łajmavaje pole",
  "block.minecraft.banner.base.magenta": "Całkam purpurnaje pole",
  "block.minecraft.banner.base.orange": "Całkam aranžavaje pole",
  "block.minecraft.banner.base.pink": "Całkam ružovaje pole",
  "block.minecraft.banner.base.purple": "Całkam fijaletavaje pole",
  "block.minecraft.banner.base.red": "Całkam čyrvonaje pole",
  "block.minecraft.banner.base.white": "Całkam biełaje pole",
  "block.minecraft.banner.base.yellow": "Całkam žoŭtaje pole",
  "block.minecraft.banner.border.black": "Čornaja lištva",
  "block.minecraft.banner.border.blue": "Siniaja lištva",
  "block.minecraft.banner.border.brown": "Karyčnievaja lištva",
  "block.minecraft.banner.border.cyan": "Biruzovaja lištva",
  "block.minecraft.banner.border.gray": "Šeraja lištva",
  "block.minecraft.banner.border.green": "Zialonaja lištva",
  "block.minecraft.banner.border.light_blue": "Błakitnaja lištva",
  "block.minecraft.banner.border.light_gray": "Svietła-šeraja lištva",
  "block.minecraft.banner.border.lime": "Łajmavaja lištva",
  "block.minecraft.banner.border.magenta": "Purpurnaja lištva",
  "block.minecraft.banner.border.orange": "Aranžavaja lištva",
  "block.minecraft.banner.border.pink": "Ružovaja lištva",
  "block.minecraft.banner.border.purple": "Fijaletavaja lištva",
  "block.minecraft.banner.border.red": "Čyrvonaja lištva",
  "block.minecraft.banner.border.white": "Biełaja lištva",
  "block.minecraft.banner.border.yellow": "Žoŭtaja lištva",
  "block.minecraft.banner.bricks.black": "Čorny mur",
  "block.minecraft.banner.bricks.blue": "Sini mur",
  "block.minecraft.banner.bricks.brown": "Karyčnievy mur",
  "block.minecraft.banner.bricks.cyan": "Biruzovy mur",
  "block.minecraft.banner.bricks.gray": "Šery mur",
  "block.minecraft.banner.bricks.green": "Zialony mur",
  "block.minecraft.banner.bricks.light_blue": "Błakitny mur",
  "block.minecraft.banner.bricks.light_gray": "Svietła-šery mur",
  "block.minecraft.banner.bricks.lime": "Łajmavy mur",
  "block.minecraft.banner.bricks.magenta": "Purpurny mur",
  "block.minecraft.banner.bricks.orange": "Aranžavy mur",
  "block.minecraft.banner.bricks.pink": "Ružovy mur",
  "block.minecraft.banner.bricks.purple": "Fijaletavy mur",
  "block.minecraft.banner.bricks.red": "Čyrvony mur",
  "block.minecraft.banner.bricks.white": "Bieły mur",
  "block.minecraft.banner.bricks.yellow": "Žoŭty mur",
  "block.minecraft.banner.circle.black": "Čorny kruh",
  "block.minecraft.banner.circle.blue": "Sini kruh",
  "block.minecraft.banner.circle.brown": "Karyčnievy kruh",
  "block.minecraft.banner.circle.cyan": "Biruzovy kruh",
  "block.minecraft.banner.circle.gray": "Šery kruh",
  "block.minecraft.banner.circle.green": "Zialony kruh",
  "block.minecraft.banner.circle.light_blue": "Błakitny kruh",
  "block.minecraft.banner.circle.light_gray": "Svietła-šery kruh",
  "block.minecraft.banner.circle.lime": "Łajmavy kruh",
  "block.minecraft.banner.circle.magenta": "Purpurny kruh",
  "block.minecraft.banner.circle.orange": "Aranžavy kruh",
  "block.minecraft.banner.circle.pink": "Ružovy kruh",
  "block.minecraft.banner.circle.purple": "Fijaletavy kruh",
  "block.minecraft.banner.circle.red": "Čyrvony kruh",
  "block.minecraft.banner.circle.white": "Bieły kruh",
  "block.minecraft.banner.circle.yellow": "Žoŭty kruh",
  "block.minecraft.banner.creeper.black": "Čornaja fihura сreepera",
  "block.minecraft.banner.creeper.blue": "Siniaja fihura creepera",
  "block.minecraft.banner.creeper.brown": "Karyčnievaja fihura creepera",
  "block.minecraft.banner.creeper.cyan": "Biruzovaja fihura creepera",
  "block.minecraft.banner.creeper.gray": "Šeraja fihura creepera",
  "block.minecraft.banner.creeper.green": "Zialonaja fihura creepera",
  "block.minecraft.banner.creeper.light_blue": "Błakitnaja fihura creepera",
  "block.minecraft.banner.creeper.light_gray": "Svietła-šeraja fihura creepera",
  "block.minecraft.banner.creeper.lime": "Łajmavaja fihura creepera",
  "block.minecraft.banner.creeper.magenta": "Purpurnaja fihura creepera",
  "block.minecraft.banner.creeper.orange": "Aranžavaja fihura creepera",
  "block.minecraft.banner.creeper.pink": "Ružovaja fihura creepera",
  "block.minecraft.banner.creeper.purple": "Fijaletavaja fihura creepera",
  "block.minecraft.banner.creeper.red": "Čyrvonaja fihura creepera",
  "block.minecraft.banner.creeper.white": "Biełaja fihura creepera",
  "block.minecraft.banner.creeper.yellow": "Žoŭtaja fihura creepera",
  "block.minecraft.banner.cross.black": "Čorny andrejeŭski kryž",
  "block.minecraft.banner.cross.blue": "Sini andrejeŭski kryž",
  "block.minecraft.banner.cross.brown": "Karyčnievy andrejeŭski kryž",
  "block.minecraft.banner.cross.cyan": "Biruzovy andrejeŭski kryž",
  "block.minecraft.banner.cross.gray": "Šery andrejeŭski kryž",
  "block.minecraft.banner.cross.green": "Zialony andrejeŭski kryž",
  "block.minecraft.banner.cross.light_blue": "Błakitny andrejeŭski kryž",
  "block.minecraft.banner.cross.light_gray": "Svietła-šery andrejeŭski kryž",
  "block.minecraft.banner.cross.lime": "Łajmavy andrejeŭski kryž",
  "block.minecraft.banner.cross.magenta": "Purpurny andrejeŭski kryž",
  "block.minecraft.banner.cross.orange": "Aranžavy andrejeŭski kryž",
  "block.minecraft.banner.cross.pink": "Ružovy andrejeŭski kryž",
  "block.minecraft.banner.cross.purple": "Fijaletavy andrejeŭski kryž",
  "block.minecraft.banner.cross.red": "Čyrvony andrejeŭski kryž",
  "block.minecraft.banner.cross.white": "Bieły andrejeŭski kryž",
  "block.minecraft.banner.cross.yellow": "Žoŭty andrejeŭski kryž",
  "block.minecraft.banner.curly_border.black": "Čornaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.blue": "Siniaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.brown": "Karyčnievaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.cyan": "Biruzovaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.gray": "Šeraja zubčastaja lištva",
  "block.minecraft.banner.curly_border.green": "Zialonaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.light_blue": "Błakitnaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.light_gray": "Svietła-šeraja zubčastaja lištva",
  "block.minecraft.banner.curly_border.lime": "Łajmavaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.magenta": "Purpurnaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.orange": "Aranžavaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.pink": "Ružovaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.purple": "Fijaletavaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.red": "Čyrvonaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.white": "Biełaja zubčastaja lištva",
  "block.minecraft.banner.curly_border.yellow": "Žoŭtaja zubčastaja lištva",
  "block.minecraft.banner.diagonal_left.black": "Čornaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.blue": "Siniaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.brown": "Karyčnievaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.cyan": "Biruzovaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.gray": "Šeraja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.green": "Zialonaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.light_blue": "Błakitnaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.light_gray": "Svietła-šeraja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.lime": "Łajmavaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.magenta": "Purpurnaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.orange": "Aranžavaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.pink": "Ružovaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.purple": "Fijaletavaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.red": "Čyrvonaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.white": "Biełaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_left.yellow": "Žoŭtaja vierchniaja levaja pałova",
  "block.minecraft.banner.diagonal_right.black": "Čornaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.blue": "Siniaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.brown": "Karyčnievaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.cyan": "Biruzovaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.gray": "Šeraja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.green": "Zialonaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.light_blue": "Błakitnaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.light_gray": "Svietła-šeraja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.lime": "Łajmavaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.magenta": "Purpurnaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.orange": "Aranžavaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.pink": "Ružovaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.purple": "Fijaletavaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.red": "Čyrvonaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.white": "Biełaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_right.yellow": "Žoŭtaja vierchniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_left.black": "Čornaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.blue": "Siniaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.brown": "Karyčnievaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.cyan": "Biruzovaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.gray": "Šeraja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.green": "Zialonaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Błakitnaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Svietła-šeraja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.lime": "Łajmavaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.magenta": "Purpurnaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.orange": "Aranžavaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.pink": "Ružovaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.purple": "Fijaletavaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.red": "Čyrvonaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.white": "Biełaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_left.yellow": "Žoŭtaja nižniaja levaja pałova",
  "block.minecraft.banner.diagonal_up_right.black": "Čornaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.blue": "Siniaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.brown": "Karyčnievaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.cyan": "Biruzovaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.gray": "Šeraja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.green": "Zialonaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Błakitnaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Svietła-šeraja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.lime": "Łajmavaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.magenta": "Purpurnaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.orange": "Aranžavaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.pink": "Ružovaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.purple": "Fijaletavaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.red": "Čyrvonaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.white": "Biełaja nižniaja pravaja pałova",
  "block.minecraft.banner.diagonal_up_right.yellow": "Žoŭtaja nižniaja pravaja pałova",
  "block.minecraft.banner.flow.black": "Čornaja płyń",
  "block.minecraft.banner.flow.blue": "Siniaja płyń",
  "block.minecraft.banner.flow.brown": "Karyčnievaja płyń",
  "block.minecraft.banner.flow.cyan": "Biruzovaja płyń",
  "block.minecraft.banner.flow.gray": "Šeraja płyń",
  "block.minecraft.banner.flow.green": "Zialonaja płyń",
  "block.minecraft.banner.flow.light_blue": "Błakitnaja płyń",
  "block.minecraft.banner.flow.light_gray": "Svietła-šeraja płyń",
  "block.minecraft.banner.flow.lime": "Łajmavaja płyń",
  "block.minecraft.banner.flow.magenta": "Purpurnaja płyń",
  "block.minecraft.banner.flow.orange": "Aranžavaja płyń",
  "block.minecraft.banner.flow.pink": "Ružovaja płyń",
  "block.minecraft.banner.flow.purple": "Fijaletavaja płyń",
  "block.minecraft.banner.flow.red": "Čyrvonaja płyń",
  "block.minecraft.banner.flow.white": "Biełaja płyń",
  "block.minecraft.banner.flow.yellow": "Žoŭtaja płyń",
  "block.minecraft.banner.flower.black": "Čornaja fihura kvietki",
  "block.minecraft.banner.flower.blue": "Siniaja fihura kvietki",
  "block.minecraft.banner.flower.brown": "Karyčnievaja fihura kvietki",
  "block.minecraft.banner.flower.cyan": "Biruzovaja fihura kvietki",
  "block.minecraft.banner.flower.gray": "Šeraja fihura kvietki",
  "block.minecraft.banner.flower.green": "Zialonaja fihura kvietki",
  "block.minecraft.banner.flower.light_blue": "Błakitnaja fihura kvietki",
  "block.minecraft.banner.flower.light_gray": "Svietła-šeraja fihura kvietki",
  "block.minecraft.banner.flower.lime": "Łajmavaja fihura kvietki",
  "block.minecraft.banner.flower.magenta": "Purpurnaja fihura kvietki",
  "block.minecraft.banner.flower.orange": "Aranžavaja fihura kvietki",
  "block.minecraft.banner.flower.pink": "Ružovaja fihura kvietki",
  "block.minecraft.banner.flower.purple": "Fijaletavaja fihura kvietki",
  "block.minecraft.banner.flower.red": "Čyrvonaja fihura kvietki",
  "block.minecraft.banner.flower.white": "Biełaja fihura kvietki",
  "block.minecraft.banner.flower.yellow": "Žoŭtaja fihura kvietki",
  "block.minecraft.banner.globe.black": "Čorny hłobus",
  "block.minecraft.banner.globe.blue": "Sini hłobus",
  "block.minecraft.banner.globe.brown": "Karyčnievy hłobus",
  "block.minecraft.banner.globe.cyan": "Biruzovy hłobus",
  "block.minecraft.banner.globe.gray": "Šery hłobus",
  "block.minecraft.banner.globe.green": "Zialony hłobus",
  "block.minecraft.banner.globe.light_blue": "Błakitny hłobus",
  "block.minecraft.banner.globe.light_gray": "Svietła-šery hłobus",
  "block.minecraft.banner.globe.lime": "Łajmavy hłobus",
  "block.minecraft.banner.globe.magenta": "Purpurny hłobus",
  "block.minecraft.banner.globe.orange": "Aranžavy hłobus",
  "block.minecraft.banner.globe.pink": "Ružovy hłobus",
  "block.minecraft.banner.globe.purple": "Fijaletavy hłobus",
  "block.minecraft.banner.globe.red": "Čyrvony hłobus",
  "block.minecraft.banner.globe.white": "Bieły hłobus",
  "block.minecraft.banner.globe.yellow": "Žoŭty hłobus",
  "block.minecraft.banner.gradient.black": "Čorny hradyjent zvierchu",
  "block.minecraft.banner.gradient.blue": "Sini hradyjent zvierchu",
  "block.minecraft.banner.gradient.brown": "Karyčnievy hradyjent zvierchu",
  "block.minecraft.banner.gradient.cyan": "Biruzovy hradyjent zvierchu",
  "block.minecraft.banner.gradient.gray": "Šery hradyjent zvierchu",
  "block.minecraft.banner.gradient.green": "Zialony hradyjent zvierchu",
  "block.minecraft.banner.gradient.light_blue": "Błakitny hradyjent zvierchu",
  "block.minecraft.banner.gradient.light_gray": "Svietła-šery hradyjent zvierchu",
  "block.minecraft.banner.gradient.lime": "Łajmavy hradyjent zvierchu",
  "block.minecraft.banner.gradient.magenta": "Purpurny hradyjent zvierchu",
  "block.minecraft.banner.gradient.orange": "Aranžavy hradyjent zvierchu",
  "block.minecraft.banner.gradient.pink": "Ružovy hradyjent zvierchu",
  "block.minecraft.banner.gradient.purple": "Fijaletavy hradyjent zvierchu",
  "block.minecraft.banner.gradient.red": "Čyrvony hradyjent zvierchu",
  "block.minecraft.banner.gradient.white": "Bieły hradyjent zvierchu",
  "block.minecraft.banner.gradient.yellow": "Žoŭty hradyjent zvierchu",
  "block.minecraft.banner.gradient_up.black": "Čorny hradyjent znizu",
  "block.minecraft.banner.gradient_up.blue": "Sini hradyjent znizu",
  "block.minecraft.banner.gradient_up.brown": "Karyčnievy hradyjent znizu",
  "block.minecraft.banner.gradient_up.cyan": "Biruzovy hradyjent znizu",
  "block.minecraft.banner.gradient_up.gray": "Šery hradyjent znizu",
  "block.minecraft.banner.gradient_up.green": "Zialony hradyjent znizu",
  "block.minecraft.banner.gradient_up.light_blue": "Błakitny hradyjent znizu",
  "block.minecraft.banner.gradient_up.light_gray": "Svietła-šery hradyjent znizu",
  "block.minecraft.banner.gradient_up.lime": "Łajmavy hradyjent znizu",
  "block.minecraft.banner.gradient_up.magenta": "Purpurny hradyjent znizu",
  "block.minecraft.banner.gradient_up.orange": "Aranžavy hradyjent znizu",
  "block.minecraft.banner.gradient_up.pink": "Ružovy hradyjent znizu",
  "block.minecraft.banner.gradient_up.purple": "Fijaletavy hradyjent znizu",
  "block.minecraft.banner.gradient_up.red": "Čyrvony hradyjent znizu",
  "block.minecraft.banner.gradient_up.white": "Bieły hradyjent znizu",
  "block.minecraft.banner.gradient_up.yellow": "Žoŭty hradyjent znizu",
  "block.minecraft.banner.guster.black": "Čorny paryŭ",
  "block.minecraft.banner.guster.blue": "Sini paryŭ",
  "block.minecraft.banner.guster.brown": "Karyčnievy paryŭ",
  "block.minecraft.banner.guster.cyan": "Biruzovy paryŭ",
  "block.minecraft.banner.guster.gray": "Šery paryŭ",
  "block.minecraft.banner.guster.green": "Zialony paryŭ",
  "block.minecraft.banner.guster.light_blue": "Błakitny paryŭ",
  "block.minecraft.banner.guster.light_gray": "Svietła-šery paryŭ",
  "block.minecraft.banner.guster.lime": "Łajmavy paryŭ",
  "block.minecraft.banner.guster.magenta": "Purpurny paryŭ",
  "block.minecraft.banner.guster.orange": "Aranžavy paryŭ",
  "block.minecraft.banner.guster.pink": "Ružovy paryŭ",
  "block.minecraft.banner.guster.purple": "Fijaletavy paryŭ",
  "block.minecraft.banner.guster.red": "Čyrvony paryŭ",
  "block.minecraft.banner.guster.white": "Bieły paryŭ",
  "block.minecraft.banner.guster.yellow": "Žoŭty paryŭ",
  "block.minecraft.banner.half_horizontal.black": "Čornaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.blue": "Siniaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.brown": "Karyčnievaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.cyan": "Biruzovaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.gray": "Šeraja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.green": "Zialonaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.light_blue": "Błakitnaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.light_gray": "Svietła-šeraja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.lime": "Łajmavaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.magenta": "Purpurnaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.orange": "Aranžavaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.pink": "Ružovaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.purple": "Fijaletavaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.red": "Čyrvonaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.white": "Biełaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal.yellow": "Žoŭtaja vierchniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.black": "Čornaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Siniaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Karyčnievaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Biruzovaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Šeraja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zialonaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Błakitnaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Svietła-šeraja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Łajmavaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Purpurnaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Aranžavaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Ružovaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Fijaletavaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.red": "Čyrvonaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.white": "Biełaja nižniaja pałova",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Žoŭtaja nižniaja pałova",
  "block.minecraft.banner.half_vertical.black": "Čornaja levaja pałova",
  "block.minecraft.banner.half_vertical.blue": "Siniaja levaja pałova",
  "block.minecraft.banner.half_vertical.brown": "Karyčnievaja levaja pałova",
  "block.minecraft.banner.half_vertical.cyan": "Biruzovaja levaja pałova",
  "block.minecraft.banner.half_vertical.gray": "Šeraja levaja pałova",
  "block.minecraft.banner.half_vertical.green": "Zialonaja levaja pałova",
  "block.minecraft.banner.half_vertical.light_blue": "Błakitnaja levaja pałova",
  "block.minecraft.banner.half_vertical.light_gray": "Svietła-šeraja levaja pałova",
  "block.minecraft.banner.half_vertical.lime": "Łajmavaja levaja pałova",
  "block.minecraft.banner.half_vertical.magenta": "Purpurnaja levaja pałova",
  "block.minecraft.banner.half_vertical.orange": "Aranžavaja levaja pałova",
  "block.minecraft.banner.half_vertical.pink": "Ružovaja levaja pałova",
  "block.minecraft.banner.half_vertical.purple": "Fijaletavaja levaja pałova",
  "block.minecraft.banner.half_vertical.red": "Čyrvonaja levaja pałova",
  "block.minecraft.banner.half_vertical.white": "Biełaja levaja pałova",
  "block.minecraft.banner.half_vertical.yellow": "Žoŭtaja levaja pałova",
  "block.minecraft.banner.half_vertical_right.black": "Čornaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.blue": "Siniaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.brown": "Karyčnievaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.cyan": "Biruzovaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.gray": "Šeraja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.green": "Zialonaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.light_blue": "Błakitnaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.light_gray": "Svietła-šeraja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.lime": "Łajmavaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.magenta": "Purpurnaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.orange": "Aranžavaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.pink": "Ružovaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.purple": "Fijaletavaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.red": "Čyrvonaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.white": "Biełaja pravaja pałova",
  "block.minecraft.banner.half_vertical_right.yellow": "Žoŭtaja pravaja pałova",
  "block.minecraft.banner.mojang.black": "Čornaje štości",
  "block.minecraft.banner.mojang.blue": "Siniaje štości",
  "block.minecraft.banner.mojang.brown": "Karyčnievaje štości",
  "block.minecraft.banner.mojang.cyan": "Biruzovaje štości",
  "block.minecraft.banner.mojang.gray": "Šeraje štości",
  "block.minecraft.banner.mojang.green": "Zialonaje štości",
  "block.minecraft.banner.mojang.light_blue": "Błakitnaje štości",
  "block.minecraft.banner.mojang.light_gray": "Svietła-šeraje štości",
  "block.minecraft.banner.mojang.lime": "Łajmavaje štości",
  "block.minecraft.banner.mojang.magenta": "Purpurnaje štości",
  "block.minecraft.banner.mojang.orange": "Aranžavaje štości",
  "block.minecraft.banner.mojang.pink": "Ružovaje štości",
  "block.minecraft.banner.mojang.purple": "Fijaletavaje štości",
  "block.minecraft.banner.mojang.red": "Čyrvonaje štości",
  "block.minecraft.banner.mojang.white": "Biełaje štości",
  "block.minecraft.banner.mojang.yellow": "Žoŭtaje štości",
  "block.minecraft.banner.piglin.black": "Čorny łyč",
  "block.minecraft.banner.piglin.blue": "Sini łyč",
  "block.minecraft.banner.piglin.brown": "Karyčnievy łyč",
  "block.minecraft.banner.piglin.cyan": "Biruzovy łyč",
  "block.minecraft.banner.piglin.gray": "Šery łyč",
  "block.minecraft.banner.piglin.green": "Zialony łyč",
  "block.minecraft.banner.piglin.light_blue": "Błakitny łyč",
  "block.minecraft.banner.piglin.light_gray": "Svietła-šery łyč",
  "block.minecraft.banner.piglin.lime": "Łajmavy łyč",
  "block.minecraft.banner.piglin.magenta": "Purpurny łyč",
  "block.minecraft.banner.piglin.orange": "Aranžavy łyč",
  "block.minecraft.banner.piglin.pink": "Ružovy łyč",
  "block.minecraft.banner.piglin.purple": "Fijaletavy łyč",
  "block.minecraft.banner.piglin.red": "Čyrvony łyč",
  "block.minecraft.banner.piglin.white": "Bieły łyč",
  "block.minecraft.banner.piglin.yellow": "Žoŭty łyč",
  "block.minecraft.banner.rhombus.black": "Čorny romb",
  "block.minecraft.banner.rhombus.blue": "Sini romb",
  "block.minecraft.banner.rhombus.brown": "Karyčnievy romb",
  "block.minecraft.banner.rhombus.cyan": "Biruzovy romb",
  "block.minecraft.banner.rhombus.gray": "Šery romb",
  "block.minecraft.banner.rhombus.green": "Zialony romb",
  "block.minecraft.banner.rhombus.light_blue": "Błakitny romb",
  "block.minecraft.banner.rhombus.light_gray": "Svietła-šery romb",
  "block.minecraft.banner.rhombus.lime": "Łajmavy romb",
  "block.minecraft.banner.rhombus.magenta": "Purpurny romb",
  "block.minecraft.banner.rhombus.orange": "Aranžavy romb",
  "block.minecraft.banner.rhombus.pink": "Ružovy romb",
  "block.minecraft.banner.rhombus.purple": "Fijaletavy romb",
  "block.minecraft.banner.rhombus.red": "Čyrvony romb",
  "block.minecraft.banner.rhombus.white": "Bieły romb",
  "block.minecraft.banner.rhombus.yellow": "Žoŭty romb",
  "block.minecraft.banner.skull.black": "Čornaja fihura čerapa",
  "block.minecraft.banner.skull.blue": "Siniaja fihura čerapa",
  "block.minecraft.banner.skull.brown": "Karyčnievaja fihura čerapa",
  "block.minecraft.banner.skull.cyan": "Biruzovaja fihura čerapa",
  "block.minecraft.banner.skull.gray": "Šeraja fihura čerapa",
  "block.minecraft.banner.skull.green": "Zialonaja fihura čerapa",
  "block.minecraft.banner.skull.light_blue": "Błakitnaja fihura čerapa",
  "block.minecraft.banner.skull.light_gray": "Svietła-šeraja fihura čerapa",
  "block.minecraft.banner.skull.lime": "Łajmavaja fihura čerapa",
  "block.minecraft.banner.skull.magenta": "Purpurnaja fihura čerapa",
  "block.minecraft.banner.skull.orange": "Aranžavaja fihura čerapa",
  "block.minecraft.banner.skull.pink": "Ružovaja fihura čerapa",
  "block.minecraft.banner.skull.purple": "Fijaletavaja fihura čerapa",
  "block.minecraft.banner.skull.red": "Čyrvonaja fihura čerapa",
  "block.minecraft.banner.skull.white": "Biełaja fihura čerapa",
  "block.minecraft.banner.skull.yellow": "Žoŭtaja fihura čerapa",
  "block.minecraft.banner.small_stripes.black": "Čornyja słupki",
  "block.minecraft.banner.small_stripes.blue": "Sinija słupki",
  "block.minecraft.banner.small_stripes.brown": "Karyčnievyja słupki",
  "block.minecraft.banner.small_stripes.cyan": "Biruzovyja słupki",
  "block.minecraft.banner.small_stripes.gray": "Šeryja słupki",
  "block.minecraft.banner.small_stripes.green": "Zialonyja słupki",
  "block.minecraft.banner.small_stripes.light_blue": "Błakitnyja słupki",
  "block.minecraft.banner.small_stripes.light_gray": "Svietła-šeryja słupki",
  "block.minecraft.banner.small_stripes.lime": "Łajmavyja słupki",
  "block.minecraft.banner.small_stripes.magenta": "Purpurnyja słupki",
  "block.minecraft.banner.small_stripes.orange": "Aranžavyja słupki",
  "block.minecraft.banner.small_stripes.pink": "Ružovyja słupki",
  "block.minecraft.banner.small_stripes.purple": "Fijaletavyja słupki",
  "block.minecraft.banner.small_stripes.red": "Čyrvonyja słupki",
  "block.minecraft.banner.small_stripes.white": "Biełyja słupki",
  "block.minecraft.banner.small_stripes.yellow": "Žoŭtyja słupki",
  "block.minecraft.banner.square_bottom_left.black": "Čorny nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.blue": "Sini nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.brown": "Karyčnievy nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.cyan": "Biruzovy nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.gray": "Šery nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.green": "Zialony nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.light_blue": "Błakitny nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.light_gray": "Svietła-šery nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.lime": "Łajmavy nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.magenta": "Purpurny nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.orange": "Aranžavy nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.pink": "Ružovy nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.purple": "Fijaletavy nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.red": "Čyrvony nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.white": "Bieły nižni kut zleva",
  "block.minecraft.banner.square_bottom_left.yellow": "Žoŭty nižni kut zleva",
  "block.minecraft.banner.square_bottom_right.black": "Čorny nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.blue": "Sini nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.brown": "Karyčnievy nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.cyan": "Biruzovy nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.gray": "Šery nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.green": "Zialony nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.light_blue": "Błakitny nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.light_gray": "Svietła-šery nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.lime": "Łajmavy nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.magenta": "Purpurny nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.orange": "Aranžavy nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.pink": "Ružovy nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.purple": "Fijaletavy nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.red": "Čyrvony nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.white": "Bieły nižni kut sprava",
  "block.minecraft.banner.square_bottom_right.yellow": "Žoŭty nižni kut sprava",
  "block.minecraft.banner.square_top_left.black": "Čorny vierchni kut zleva",
  "block.minecraft.banner.square_top_left.blue": "Sini vierchni kut zleva",
  "block.minecraft.banner.square_top_left.brown": "Karyčnievy vierchni kut zleva",
  "block.minecraft.banner.square_top_left.cyan": "Biruzovy vierchni kut zleva",
  "block.minecraft.banner.square_top_left.gray": "Šery vierchni kut zleva",
  "block.minecraft.banner.square_top_left.green": "Zialony vierchni kut zleva",
  "block.minecraft.banner.square_top_left.light_blue": "Błakitny vierchni kut zleva",
  "block.minecraft.banner.square_top_left.light_gray": "Svietła-šery vierchni kut zleva",
  "block.minecraft.banner.square_top_left.lime": "Łajmavy vierchni kut zleva",
  "block.minecraft.banner.square_top_left.magenta": "Purpurny vierchni kut zleva",
  "block.minecraft.banner.square_top_left.orange": "Aranžavy vierchni kut zleva",
  "block.minecraft.banner.square_top_left.pink": "Ružovy vierchni kut zleva",
  "block.minecraft.banner.square_top_left.purple": "Fijaletavy vierchni kut zleva",
  "block.minecraft.banner.square_top_left.red": "Čyrvony vierchni kut zleva",
  "block.minecraft.banner.square_top_left.white": "Bieły vierchni kut zleva",
  "block.minecraft.banner.square_top_left.yellow": "Žoŭty vierchni kut zleva",
  "block.minecraft.banner.square_top_right.black": "Čorny vierchni kut sprava",
  "block.minecraft.banner.square_top_right.blue": "Sini vierchni kut sprava",
  "block.minecraft.banner.square_top_right.brown": "Karyčnievy vierchni kut sprava",
  "block.minecraft.banner.square_top_right.cyan": "Biruzovy vierchni kut sprava",
  "block.minecraft.banner.square_top_right.gray": "Šery vierchni kut sprava",
  "block.minecraft.banner.square_top_right.green": "Zialony vierchni kut sprava",
  "block.minecraft.banner.square_top_right.light_blue": "Błakitny vierchni kut sprava",
  "block.minecraft.banner.square_top_right.light_gray": "Svietła-šery vierchni kut sprava",
  "block.minecraft.banner.square_top_right.lime": "Łajmavy vierchni kut sprava",
  "block.minecraft.banner.square_top_right.magenta": "Purpurny vierchni kut sprava",
  "block.minecraft.banner.square_top_right.orange": "Aranžavy vierchni kut sprava",
  "block.minecraft.banner.square_top_right.pink": "Ružovy vierchni kut sprava",
  "block.minecraft.banner.square_top_right.purple": "Fijaletavy vierchni kut sprava",
  "block.minecraft.banner.square_top_right.red": "Čyrvony vierchni kut sprava",
  "block.minecraft.banner.square_top_right.white": "Bieły vierchni kut sprava",
  "block.minecraft.banner.square_top_right.yellow": "Žoŭty vierchni kut sprava",
  "block.minecraft.banner.straight_cross.black": "Čorny kryž",
  "block.minecraft.banner.straight_cross.blue": "Sini kryž",
  "block.minecraft.banner.straight_cross.brown": "Karyčnievy kryž",
  "block.minecraft.banner.straight_cross.cyan": "Biruzovy kryž",
  "block.minecraft.banner.straight_cross.gray": "Šery kryž",
  "block.minecraft.banner.straight_cross.green": "Zialony kryž",
  "block.minecraft.banner.straight_cross.light_blue": "Błakitny kryž",
  "block.minecraft.banner.straight_cross.light_gray": "Svietła-šery kryž",
  "block.minecraft.banner.straight_cross.lime": "Łajmavy kryž",
  "block.minecraft.banner.straight_cross.magenta": "Purpurny kryž",
  "block.minecraft.banner.straight_cross.orange": "Aranžavy kryž",
  "block.minecraft.banner.straight_cross.pink": "Ružovy kryž",
  "block.minecraft.banner.straight_cross.purple": "Fijaletavy kryž",
  "block.minecraft.banner.straight_cross.red": "Čyrvony kryž",
  "block.minecraft.banner.straight_cross.white": "Bieły kryž",
  "block.minecraft.banner.straight_cross.yellow": "Žoŭty kryž",
  "block.minecraft.banner.stripe_bottom.black": "Čorny padnožak",
  "block.minecraft.banner.stripe_bottom.blue": "Sini padnožak",
  "block.minecraft.banner.stripe_bottom.brown": "Karyčnievy padnožak",
  "block.minecraft.banner.stripe_bottom.cyan": "Biruzovy padnožak",
  "block.minecraft.banner.stripe_bottom.gray": "Šery padnožak",
  "block.minecraft.banner.stripe_bottom.green": "Zialony padnožak",
  "block.minecraft.banner.stripe_bottom.light_blue": "Błakitny padnožak",
  "block.minecraft.banner.stripe_bottom.light_gray": "Svietła-šery padnožak",
  "block.minecraft.banner.stripe_bottom.lime": "Łajmavy padnožak",
  "block.minecraft.banner.stripe_bottom.magenta": "Purpurny padnožak",
  "block.minecraft.banner.stripe_bottom.orange": "Aranžavy padnožak",
  "block.minecraft.banner.stripe_bottom.pink": "Ružovy padnožak",
  "block.minecraft.banner.stripe_bottom.purple": "Fijaletavy padnožak",
  "block.minecraft.banner.stripe_bottom.red": "Čyrvony padnožak",
  "block.minecraft.banner.stripe_bottom.white": "Bieły padnožak",
  "block.minecraft.banner.stripe_bottom.yellow": "Žoŭty padnožak",
  "block.minecraft.banner.stripe_center.black": "Čorny słup",
  "block.minecraft.banner.stripe_center.blue": "Sini słup",
  "block.minecraft.banner.stripe_center.brown": "Karyčnievy słup",
  "block.minecraft.banner.stripe_center.cyan": "Biruzovy słup",
  "block.minecraft.banner.stripe_center.gray": "Šery słup",
  "block.minecraft.banner.stripe_center.green": "Zialony słup",
  "block.minecraft.banner.stripe_center.light_blue": "Błakitny słup",
  "block.minecraft.banner.stripe_center.light_gray": "Svietła-šery słup",
  "block.minecraft.banner.stripe_center.lime": "Łajmavy słup",
  "block.minecraft.banner.stripe_center.magenta": "Purpurny słup",
  "block.minecraft.banner.stripe_center.orange": "Aranžavy słup",
  "block.minecraft.banner.stripe_center.pink": "Ružovy słup",
  "block.minecraft.banner.stripe_center.purple": "Fijaletavy słup",
  "block.minecraft.banner.stripe_center.red": "Čyrvony słup",
  "block.minecraft.banner.stripe_center.white": "Bieły słup",
  "block.minecraft.banner.stripe_center.yellow": "Žoŭty słup",
  "block.minecraft.banner.stripe_downleft.black": "Čornaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.blue": "Siniaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.brown": "Karyčnievaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.cyan": "Biruzovaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.gray": "Šeraja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.green": "Zialonaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.light_blue": "Błakitnaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.light_gray": "Svietła-šeraja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.lime": "Łajmavaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.magenta": "Purpurnaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.orange": "Aranžavaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.pink": "Ružovaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.purple": "Fijaletavaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.red": "Čyrvonaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.white": "Biełaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downleft.yellow": "Žoŭtaja levaja pieraviaź",
  "block.minecraft.banner.stripe_downright.black": "Čornaja pieraviaź",
  "block.minecraft.banner.stripe_downright.blue": "Siniaja pieraviaź",
  "block.minecraft.banner.stripe_downright.brown": "Karyčnievaja pieraviaź",
  "block.minecraft.banner.stripe_downright.cyan": "Biruzovaja pieraviaź",
  "block.minecraft.banner.stripe_downright.gray": "Šeraja pieraviaź",
  "block.minecraft.banner.stripe_downright.green": "Zialonaja pieraviaź",
  "block.minecraft.banner.stripe_downright.light_blue": "Błakitnaja pieraviaź",
  "block.minecraft.banner.stripe_downright.light_gray": "Svietła-šeraja pieraviaź",
  "block.minecraft.banner.stripe_downright.lime": "Łajmavaja pieraviaź",
  "block.minecraft.banner.stripe_downright.magenta": "Purpurnaja pieraviaź",
  "block.minecraft.banner.stripe_downright.orange": "Aranžavaja pieraviaź",
  "block.minecraft.banner.stripe_downright.pink": "Ružovaja pieraviaź",
  "block.minecraft.banner.stripe_downright.purple": "Fijaletavaja pieraviaź",
  "block.minecraft.banner.stripe_downright.red": "Čyrvonaja pieraviaź",
  "block.minecraft.banner.stripe_downright.white": "Biełaja pieraviaź",
  "block.minecraft.banner.stripe_downright.yellow": "Žoŭtaja pieraviaź",
  "block.minecraft.banner.stripe_left.black": "Čornaja levaja treć",
  "block.minecraft.banner.stripe_left.blue": "Siniaja levaja treć",
  "block.minecraft.banner.stripe_left.brown": "Karyčnievaja levaja treć",
  "block.minecraft.banner.stripe_left.cyan": "Biruzovaja levaja treć",
  "block.minecraft.banner.stripe_left.gray": "Šeraja levaja treć",
  "block.minecraft.banner.stripe_left.green": "Zialonaja levaja treć",
  "block.minecraft.banner.stripe_left.light_blue": "Błakitnaja levaja treć",
  "block.minecraft.banner.stripe_left.light_gray": "Svietła-šeraja levaja treć",
  "block.minecraft.banner.stripe_left.lime": "Łajmavaja levaja treć",
  "block.minecraft.banner.stripe_left.magenta": "Purpurnaja levaja treć",
  "block.minecraft.banner.stripe_left.orange": "Aranžavaja levaja treć",
  "block.minecraft.banner.stripe_left.pink": "Ružovaja levaja treć",
  "block.minecraft.banner.stripe_left.purple": "Fijaletavaja levaja treć",
  "block.minecraft.banner.stripe_left.red": "Čyrvonaja levaja treć",
  "block.minecraft.banner.stripe_left.white": "Biełaja levaja treć",
  "block.minecraft.banner.stripe_left.yellow": "Žoŭtaja levaja treć",
  "block.minecraft.banner.stripe_middle.black": "Čorny pas",
  "block.minecraft.banner.stripe_middle.blue": "Sini pas",
  "block.minecraft.banner.stripe_middle.brown": "Karyčnievy pas",
  "block.minecraft.banner.stripe_middle.cyan": "Biruzovy pas",
  "block.minecraft.banner.stripe_middle.gray": "Šery pas",
  "block.minecraft.banner.stripe_middle.green": "Zialony pas",
  "block.minecraft.banner.stripe_middle.light_blue": "Błakitny pas",
  "block.minecraft.banner.stripe_middle.light_gray": "Svietła-šery pas",
  "block.minecraft.banner.stripe_middle.lime": "Łajmavy pas",
  "block.minecraft.banner.stripe_middle.magenta": "Purpurny pas",
  "block.minecraft.banner.stripe_middle.orange": "Aranžavy pas",
  "block.minecraft.banner.stripe_middle.pink": "Ružovy pas",
  "block.minecraft.banner.stripe_middle.purple": "Fijaletavy pas",
  "block.minecraft.banner.stripe_middle.red": "Čyrvony pas",
  "block.minecraft.banner.stripe_middle.white": "Bieły pas",
  "block.minecraft.banner.stripe_middle.yellow": "Žoŭty pas",
  "block.minecraft.banner.stripe_right.black": "Čornaja pravaja treć",
  "block.minecraft.banner.stripe_right.blue": "Siniaja pravaja treć",
  "block.minecraft.banner.stripe_right.brown": "Karyčnievaja pravaja treć",
  "block.minecraft.banner.stripe_right.cyan": "Biruzovaja pravaja treć",
  "block.minecraft.banner.stripe_right.gray": "Šeraja pravaja treć",
  "block.minecraft.banner.stripe_right.green": "Zialonaja pravaja treć",
  "block.minecraft.banner.stripe_right.light_blue": "Błakitnaja pravaja treć",
  "block.minecraft.banner.stripe_right.light_gray": "Svietła-šeraja pravaja treć",
  "block.minecraft.banner.stripe_right.lime": "Łajmavaja pravaja treć",
  "block.minecraft.banner.stripe_right.magenta": "Purpurnaja pravaja treć",
  "block.minecraft.banner.stripe_right.orange": "Aranžavaja pravaja treć",
  "block.minecraft.banner.stripe_right.pink": "Ružovaja pravaja treć",
  "block.minecraft.banner.stripe_right.purple": "Fijaletavaja pravaja treć",
  "block.minecraft.banner.stripe_right.red": "Čyrvonaja pravaja treć",
  "block.minecraft.banner.stripe_right.white": "Biełaja pravaja treć",
  "block.minecraft.banner.stripe_right.yellow": "Žoŭtaja pravaja treć",
  "block.minecraft.banner.stripe_top.black": "Čornaja viaršynia",
  "block.minecraft.banner.stripe_top.blue": "Siniaja viaršynia",
  "block.minecraft.banner.stripe_top.brown": "Karyčnievaja viaršynia",
  "block.minecraft.banner.stripe_top.cyan": "Biruzovaja viaršynia",
  "block.minecraft.banner.stripe_top.gray": "Šeraja viaršynia",
  "block.minecraft.banner.stripe_top.green": "Zialonaja viaršynia",
  "block.minecraft.banner.stripe_top.light_blue": "Błakitnaja viaršynia",
  "block.minecraft.banner.stripe_top.light_gray": "Svietła-šeraja viaršynia",
  "block.minecraft.banner.stripe_top.lime": "Łajmavaja viaršynia",
  "block.minecraft.banner.stripe_top.magenta": "Purpurnaja viaršynia",
  "block.minecraft.banner.stripe_top.orange": "Aranžavaja viaršynia",
  "block.minecraft.banner.stripe_top.pink": "Ružovaja viaršynia",
  "block.minecraft.banner.stripe_top.purple": "Fijaletavaja viaršynia",
  "block.minecraft.banner.stripe_top.red": "Čyrvonaja viaršynia",
  "block.minecraft.banner.stripe_top.white": "Biełaja viaršynia",
  "block.minecraft.banner.stripe_top.yellow": "Žoŭtaja viaršynia",
  "block.minecraft.banner.triangle_bottom.black": "Čornaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.blue": "Siniaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.brown": "Karyčnievaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.cyan": "Biruzovaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.gray": "Šeraje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.green": "Zialonaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.light_blue": "Błakitnaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.light_gray": "Svietła-šeraje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.lime": "Łajmavaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.magenta": "Purpurnaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.orange": "Aranžavaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.pink": "Ružovaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.purple": "Fijaletavaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.red": "Čyrvonaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.white": "Biełaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_bottom.yellow": "Žoŭtaje skaročanaje vastryjo",
  "block.minecraft.banner.triangle_top.black": "Čornaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.blue": "Siniaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.brown": "Karyčnievaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.cyan": "Biruzovaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.gray": "Šeraje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.green": "Zialonaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.light_blue": "Błakitnaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.light_gray": "Svietła-šeraje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.lime": "Łajmavaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.magenta": "Purpurnaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.orange": "Aranžavaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.pink": "Ružovaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.purple": "Fijaletavaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.red": "Čyrvonaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.white": "Biełaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangle_top.yellow": "Žoŭtaje skaročanaje pierakulenaje vastryjo",
  "block.minecraft.banner.triangles_bottom.black": "Čorny zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.blue": "Sini zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.brown": "Karyčnievy zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.cyan": "Biruzovy zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.gray": "Šery zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.green": "Zialony zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.light_blue": "Błakitny zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.light_gray": "Svietła-šery zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.lime": "Łajmavy zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.magenta": "Purpurny zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.orange": "Aranžavy zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.pink": "Ružovy zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.purple": "Fijaletavy zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.red": "Čyrvony zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.white": "Bieły zubčasty padnožak",
  "block.minecraft.banner.triangles_bottom.yellow": "Žoŭty zubčasty padnožak",
  "block.minecraft.banner.triangles_top.black": "Čornaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.blue": "Siniaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.brown": "Karyčnievaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.cyan": "Biruzovaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.gray": "Šeraja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.green": "Zialonaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.light_blue": "Błakitnaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.light_gray": "Svietła-šeraja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.lime": "Łajmavaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.magenta": "Purpurnaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.orange": "Aranžavaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.pink": "Ružovaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.purple": "Fijaletavaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.red": "Čyrvonaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.white": "Biełaja zubčastaja viaršynia",
  "block.minecraft.banner.triangles_top.yellow": "Žoŭtaja zubčastaja viaršynia",
  "block.minecraft.barrel": "Bočka",
  "block.minecraft.barrier": "Barjer",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Majak",
  "block.minecraft.beacon.primary": "Asnoŭny efiekt",
  "block.minecraft.beacon.secondary": "Dadatkovy efiekt",
  "block.minecraft.bed.no_sleep": "Vy možacie spać tolki ŭnačy abo padčas navalnicy",
  "block.minecraft.bed.not_safe": "Zaraz nielha spać, dzieści pobač pačvary!",
  "block.minecraft.bed.obstructed": "Na hety łožak nielha lehčy",
  "block.minecraft.bed.occupied": "Hety łožak zaniaty",
  "block.minecraft.bed.too_far_away": "Vy nie možacie lehčy, łožak zanadta daloka",
  "block.minecraft.bedrock": "Karennaja paroda",
  "block.minecraft.bee_nest": "Pčalinaje hniazdo",
  "block.minecraft.beehive": "Vulej",
  "block.minecraft.beetroots": "Burak",
  "block.minecraft.bell": "Zvon",
  "block.minecraft.big_dripleaf": "Vialiki kroplalist",
  "block.minecraft.big_dripleaf_stem": "Sciabło vialikaha kroplalistu",
  "block.minecraft.birch_button": "Biarozavaja knopka",
  "block.minecraft.birch_door": "Biarozavyja dzviery",
  "block.minecraft.birch_fence": "Biarozavy płot",
  "block.minecraft.birch_fence_gate": "Biarozavaja bramka",
  "block.minecraft.birch_hanging_sign": "Biarozavaja padviesnaja šylda",
  "block.minecraft.birch_leaves": "Biarozavaje liscie",
  "block.minecraft.birch_log": "Biarozavaje bierviano",
  "block.minecraft.birch_planks": "Biarozavyja doški",
  "block.minecraft.birch_pressure_plate": "Biarozavaja nacisknaja plita",
  "block.minecraft.birch_sapling": "Sadžaniec biarozy",
  "block.minecraft.birch_shelf": "Biarozavaja palica",
  "block.minecraft.birch_sign": "Biarozavaja šylda",
  "block.minecraft.birch_slab": "Biarozavaja plita",
  "block.minecraft.birch_stairs": "Biarozavyja prystupki",
  "block.minecraft.birch_trapdoor": "Biarozavy luk",
  "block.minecraft.birch_wall_hanging_sign": "Biarozavaja nasciennaja padviesnaja šylda",
  "block.minecraft.birch_wall_sign": "Biarozavaja nasciennaja šylda",
  "block.minecraft.birch_wood": "Biarozavaja draŭnina",
  "block.minecraft.black_banner": "Čorny sciah",
  "block.minecraft.black_bed": "Čorny łožak",
  "block.minecraft.black_candle": "Čornaja sviečka",
  "block.minecraft.black_candle_cake": "Tort z čornaj sviečkaj",
  "block.minecraft.black_carpet": "Čorny dyvan",
  "block.minecraft.black_concrete": "Čorny bieton",
  "block.minecraft.black_concrete_powder": "Čorny cemient",
  "block.minecraft.black_glazed_terracotta": "Čornaja palivanaja kieramika",
  "block.minecraft.black_shulker_box": "Čornaja shulkeravaja skrynia",
  "block.minecraft.black_stained_glass": "Čornaje škło",
  "block.minecraft.black_stained_glass_pane": "Čornaja šyba",
  "block.minecraft.black_terracotta": "Čornaja kieramika",
  "block.minecraft.black_wool": "Čornaja voŭna",
  "block.minecraft.blackstone": "Čarnit",
  "block.minecraft.blackstone_slab": "Plita z čarnitu",
  "block.minecraft.blackstone_stairs": "Prystupki z čarnitu",
  "block.minecraft.blackstone_wall": "Sciana z čarnitu",
  "block.minecraft.blast_furnace": "Domiennaja pieč",
  "block.minecraft.blue_banner": "Sini sciah",
  "block.minecraft.blue_bed": "Sini łožak",
  "block.minecraft.blue_candle": "Siniaja sviečka",
  "block.minecraft.blue_candle_cake": "Tort z siniaj sviečkaj",
  "block.minecraft.blue_carpet": "Sini dyvan",
  "block.minecraft.blue_concrete": "Sini bieton",
  "block.minecraft.blue_concrete_powder": "Sini cemient",
  "block.minecraft.blue_glazed_terracotta": "Siniaja palivanaja kieramika",
  "block.minecraft.blue_ice": "Sini lod",
  "block.minecraft.blue_orchid": "Błakitnaja archideja",
  "block.minecraft.blue_shulker_box": "Siniaja shulkeravaja skrynia",
  "block.minecraft.blue_stained_glass": "Siniaje škło",
  "block.minecraft.blue_stained_glass_pane": "Siniaja šyba",
  "block.minecraft.blue_terracotta": "Siniaja kieramika",
  "block.minecraft.blue_wool": "Siniaja voŭna",
  "block.minecraft.bone_block": "Kasciavy błok",
  "block.minecraft.bookshelf": "Knižnaja palička",
  "block.minecraft.brain_coral": "Mazgavy karał",
  "block.minecraft.brain_coral_block": "Błok mazgavoha karała",
  "block.minecraft.brain_coral_fan": "Viejerny mazgavy karał",
  "block.minecraft.brain_coral_wall_fan": "Haryzantalny viejerny mazgavy karał",
  "block.minecraft.brewing_stand": "Varačnaja stojka",
  "block.minecraft.brick_slab": "Caglanaja plita",
  "block.minecraft.brick_stairs": "Caglanyja prystupki",
  "block.minecraft.brick_wall": "Caglanaja sciana",
  "block.minecraft.bricks": "Cegła",
  "block.minecraft.brown_banner": "Karyčnievy sciah",
  "block.minecraft.brown_bed": "Karyčnievy łožak",
  "block.minecraft.brown_candle": "Karyčnievaja sviečka",
  "block.minecraft.brown_candle_cake": "Tort z karyčnievaj sviečkaj",
  "block.minecraft.brown_carpet": "Karyčnievy dyvan",
  "block.minecraft.brown_concrete": "Karyčnievy bieton",
  "block.minecraft.brown_concrete_powder": "Karyčnievy cemient",
  "block.minecraft.brown_glazed_terracotta": "Karyčnievaja palivanaja kieramika",
  "block.minecraft.brown_mushroom": "Baravik",
  "block.minecraft.brown_mushroom_block": "Błok baravika",
  "block.minecraft.brown_shulker_box": "Karyčnievaja shulkeravaja skrynia",
  "block.minecraft.brown_stained_glass": "Karyčnievaje škło",
  "block.minecraft.brown_stained_glass_pane": "Karyčnievaja šyba",
  "block.minecraft.brown_terracotta": "Karyčnievaja kieramika",
  "block.minecraft.brown_wool": "Karyčnievaja voŭna",
  "block.minecraft.bubble_column": "Kałona burbałak",
  "block.minecraft.bubble_coral": "Puzyrysty karał",
  "block.minecraft.bubble_coral_block": "Błok puzyrystaha karała",
  "block.minecraft.bubble_coral_fan": "Viejerny puzyrysty karał",
  "block.minecraft.bubble_coral_wall_fan": "Haryzantalny viejerny puzyrysty karał",
  "block.minecraft.budding_amethyst": "Radovišča amietystu",
  "block.minecraft.bush": "Kust",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kvietka kaktusa",
  "block.minecraft.cake": "Tort",
  "block.minecraft.calcite": "Kalcyt",
  "block.minecraft.calibrated_sculk_sensor": "Adkalibravany sculkavy sensar",
  "block.minecraft.campfire": "Vohnišča",
  "block.minecraft.candle": "Sviečka",
  "block.minecraft.candle_cake": "Tort sa sviečkaj",
  "block.minecraft.carrots": "Morkva",
  "block.minecraft.cartography_table": "Varštat kartohrafa",
  "block.minecraft.carved_pumpkin": "Vyrazany harbuz",
  "block.minecraft.cauldron": "Kacioł",
  "block.minecraft.cave_air": "Piačornaje pavietra",
  "block.minecraft.cave_vines": "Piačornaja łaza",
  "block.minecraft.cave_vines_plant": "Sciabło piačornaj łazy",
  "block.minecraft.chain": "Łancuh",
  "block.minecraft.chain_command_block": "Łancuhovy kamandny błok",
  "block.minecraft.cherry_button": "Knopka z višniovaj draŭniny",
  "block.minecraft.cherry_door": "Dzviery z višniovaj draŭniny",
  "block.minecraft.cherry_fence": "Płot z višniovaj draŭniny",
  "block.minecraft.cherry_fence_gate": "Bramka z višniovaj draŭniny",
  "block.minecraft.cherry_hanging_sign": "Padviesnaja šylda z višniovaj draŭniny",
  "block.minecraft.cherry_leaves": "Višniovaje liscie",
  "block.minecraft.cherry_log": "Višniovaje bierviano",
  "block.minecraft.cherry_planks": "Doški z višniovaj draŭniny",
  "block.minecraft.cherry_pressure_plate": "Nacisknaja plita z višniovaj draŭniny",
  "block.minecraft.cherry_sapling": "Sadžaniec višni",
  "block.minecraft.cherry_shelf": "Palica z višniovaj draŭniny",
  "block.minecraft.cherry_sign": "Šylda z višniovaj draŭniny",
  "block.minecraft.cherry_slab": "Plita z višniovaj draŭniny",
  "block.minecraft.cherry_stairs": "Prystupki z višniovaj draŭniny",
  "block.minecraft.cherry_trapdoor": "Luk z višniovaj draŭniny",
  "block.minecraft.cherry_wall_hanging_sign": "Nasciennaja padviesnaja šylda z višniovaj draŭniny",
  "block.minecraft.cherry_wall_sign": "Nasciennaja šylda z višniovaj draŭniny",
  "block.minecraft.cherry_wood": "Višniovaja draŭnina",
  "block.minecraft.chest": "Kufar",
  "block.minecraft.chipped_anvil": "Paškodžanaje kavadła",
  "block.minecraft.chiseled_bookshelf": "Raźbianaja knižnaja palička",
  "block.minecraft.chiseled_copper": "Raźbianaja miedź",
  "block.minecraft.chiseled_deepslate": "Raźbiany słaniec",
  "block.minecraft.chiseled_nether_bricks": "Raźbianaja netherskaja cegła",
  "block.minecraft.chiseled_polished_blackstone": "Raźbiany paliravany čarnit",
  "block.minecraft.chiseled_quartz_block": "Raźbiany kvarcavy błok",
  "block.minecraft.chiseled_red_sandstone": "Raźbiany čyrvony piasčanik",
  "block.minecraft.chiseled_resin_bricks": "Raźbianaja smalanaja cegła",
  "block.minecraft.chiseled_sandstone": "Raźbiany piasčanik",
  "block.minecraft.chiseled_stone_bricks": "Raźbianaja kamiennaja cegła",
  "block.minecraft.chiseled_tuff": "Raźbiany tuf",
  "block.minecraft.chiseled_tuff_bricks": "Raźbianaja tufavaja cegła",
  "block.minecraft.chorus_flower": "Kvietka chorusa",
  "block.minecraft.chorus_plant": "Chorus",
  "block.minecraft.clay": "Hlina",
  "block.minecraft.closed_eyeblossom": "Zakryty vokacviet",
  "block.minecraft.coal_block": "Vuhalny błok",
  "block.minecraft.coal_ore": "Vuhalnaja ruda",
  "block.minecraft.coarse_dirt": "Hrubaja ziamla",
  "block.minecraft.cobbled_deepslate": "Butavy słaniec",
  "block.minecraft.cobbled_deepslate_slab": "Plita z butavaha słancu",
  "block.minecraft.cobbled_deepslate_stairs": "Prystupki z butavaha słancu",
  "block.minecraft.cobbled_deepslate_wall": "Sciana z butavaha słancu",
  "block.minecraft.cobblestone": "But",
  "block.minecraft.cobblestone_slab": "Plita z butu",
  "block.minecraft.cobblestone_stairs": "Prystupki z butu",
  "block.minecraft.cobblestone_wall": "Sciana z butu",
  "block.minecraft.cobweb": "Pavucinnie",
  "block.minecraft.cocoa": "Kakava",
  "block.minecraft.command_block": "Kamandny błok",
  "block.minecraft.comparator": "Kamparatar",
  "block.minecraft.composter": "Kampostavaja skrynia",
  "block.minecraft.conduit": "Sfiera marskich čaraŭ",
  "block.minecraft.copper_bars": "Miadzianyja kraty",
  "block.minecraft.copper_block": "Miadziany błok",
  "block.minecraft.copper_bulb": "Miadzianaja lampa",
  "block.minecraft.copper_chain": "Miadziany łancuh",
  "block.minecraft.copper_chest": "Miadziany kufar",
  "block.minecraft.copper_door": "Miadzianyja dzviery",
  "block.minecraft.copper_golem_statue": "Statuja miadzianaha holema",
  "block.minecraft.copper_grate": "Miadzianaja rašotka",
  "block.minecraft.copper_lantern": "Miadziany lichtar",
  "block.minecraft.copper_ore": "Miadzianaja ruda",
  "block.minecraft.copper_torch": "Miadziany fakieł",
  "block.minecraft.copper_trapdoor": "Miadziany luk",
  "block.minecraft.copper_wall_torch": "Nascienny miadziany fakieł",
  "block.minecraft.cornflower": "Vałoška",
  "block.minecraft.cracked_deepslate_bricks": "Patreskanaja słancavaja cegła",
  "block.minecraft.cracked_deepslate_tiles": "Patreskanaja słancavaja kafla",
  "block.minecraft.cracked_nether_bricks": "Patreskanaja netherskaja cegła",
  "block.minecraft.cracked_polished_blackstone_bricks": "Patreskanaja cegła z paliravanaha čarnitu",
  "block.minecraft.cracked_stone_bricks": "Patreskanaja kamiennaja cegła",
  "block.minecraft.crafter": "Aŭtavarštat",
  "block.minecraft.crafting_table": "Varštat",
  "block.minecraft.creaking_heart": "Ryplivaje serca",
  "block.minecraft.creeper_head": "Hałava creepera",
  "block.minecraft.creeper_wall_head": "Nasciennaja hałava creepera",
  "block.minecraft.crimson_button": "Barvovaja knopka",
  "block.minecraft.crimson_door": "Barvovyja dzviery",
  "block.minecraft.crimson_fence": "Barvovy płot",
  "block.minecraft.crimson_fence_gate": "Barvovaja bramka",
  "block.minecraft.crimson_fungus": "Barvovy hryb",
  "block.minecraft.crimson_hanging_sign": "Barvovaja padviesnaja šylda",
  "block.minecraft.crimson_hyphae": "Barvovyja hify",
  "block.minecraft.crimson_nylium": "Barvovy nilij",
  "block.minecraft.crimson_planks": "Barvovyja doški",
  "block.minecraft.crimson_pressure_plate": "Barvovaja nacisknaja plita",
  "block.minecraft.crimson_roots": "Barvovyja karani",
  "block.minecraft.crimson_shelf": "Barvovaja palica",
  "block.minecraft.crimson_sign": "Barvovaja šylda",
  "block.minecraft.crimson_slab": "Barvovaja plita",
  "block.minecraft.crimson_stairs": "Barvovyja prystupki",
  "block.minecraft.crimson_stem": "Barvovaje sciabło",
  "block.minecraft.crimson_trapdoor": "Barvovy luk",
  "block.minecraft.crimson_wall_hanging_sign": "Barvovaja nasciennaja padviesnaja šylda",
  "block.minecraft.crimson_wall_sign": "Barvovaja nasciennaja šylda",
  "block.minecraft.crying_obsidian": "Płakučy absidyjan",
  "block.minecraft.cut_copper": "Raznaja miedź",
  "block.minecraft.cut_copper_slab": "Plita z raznoj miedzi",
  "block.minecraft.cut_copper_stairs": "Prystupki z raznoj miedzi",
  "block.minecraft.cut_red_sandstone": "Razny čyrvony piasčanik",
  "block.minecraft.cut_red_sandstone_slab": "Plita z raznoha čyrvonaha piasčaniku",
  "block.minecraft.cut_sandstone": "Razny piasčanik",
  "block.minecraft.cut_sandstone_slab": "Plita z raznoha piasčaniku",
  "block.minecraft.cyan_banner": "Biruzovy sciah",
  "block.minecraft.cyan_bed": "Biruzovy łožak",
  "block.minecraft.cyan_candle": "Biruzovaja sviečka",
  "block.minecraft.cyan_candle_cake": "Tort z biruzovaj sviečkaj",
  "block.minecraft.cyan_carpet": "Biruzovy dyvan",
  "block.minecraft.cyan_concrete": "Biruzovy bieton",
  "block.minecraft.cyan_concrete_powder": "Biruzovy cemient",
  "block.minecraft.cyan_glazed_terracotta": "Biruzovaja palivanaja kieramika",
  "block.minecraft.cyan_shulker_box": "Biruzovaja shulkeravaja skrynia",
  "block.minecraft.cyan_stained_glass": "Biruzovaje škło",
  "block.minecraft.cyan_stained_glass_pane": "Biruzovaja šyba",
  "block.minecraft.cyan_terracotta": "Biruzovaja kieramika",
  "block.minecraft.cyan_wool": "Biruzovaja voŭna",
  "block.minecraft.damaged_anvil": "Pałamanaje kavadła",
  "block.minecraft.dandelion": "Dźmuchaviec",
  "block.minecraft.dark_oak_button": "Knopka z ciomnaha dubu",
  "block.minecraft.dark_oak_door": "Dzviery z ciomnaha dubu",
  "block.minecraft.dark_oak_fence": "Płot z ciomnaha dubu",
  "block.minecraft.dark_oak_fence_gate": "Bramka z ciomnaha dubu",
  "block.minecraft.dark_oak_hanging_sign": "Padviesnaja šylda z ciomnaha dubu",
  "block.minecraft.dark_oak_leaves": "Liscie ciomnaha duba",
  "block.minecraft.dark_oak_log": "Bierviano z ciomnaha dubu",
  "block.minecraft.dark_oak_planks": "Doški z ciomnaha dubu",
  "block.minecraft.dark_oak_pressure_plate": "Nacisknaja plita z ciomnaha dubu",
  "block.minecraft.dark_oak_sapling": "Sadžaniec ciomnaha duba",
  "block.minecraft.dark_oak_shelf": "Palica z ciomnaha dubu",
  "block.minecraft.dark_oak_sign": "Šylda z ciomnaha dubu",
  "block.minecraft.dark_oak_slab": "Plita z ciomnaha dubu",
  "block.minecraft.dark_oak_stairs": "Prystupki z ciomnaha dubu",
  "block.minecraft.dark_oak_trapdoor": "Luk z ciomnaha dubu",
  "block.minecraft.dark_oak_wall_hanging_sign": "Nasciennaja padviesnaja šylda z ciomnaha dubu",
  "block.minecraft.dark_oak_wall_sign": "Nasciennaja šylda z ciomnaha dubu",
  "block.minecraft.dark_oak_wood": "Draŭnina ciomnaha duba",
  "block.minecraft.dark_prismarine": "Ciomny pryzmaryn",
  "block.minecraft.dark_prismarine_slab": "Plita z ciomnaha pryzmarynu",
  "block.minecraft.dark_prismarine_stairs": "Ciomnyja pryzmarynavyja prystupki",
  "block.minecraft.daylight_detector": "Datčyk dzionnaha sviatła",
  "block.minecraft.dead_brain_coral": "Miortvy mazgavy karał",
  "block.minecraft.dead_brain_coral_block": "Błok miortvaha mazgavoha karała",
  "block.minecraft.dead_brain_coral_fan": "Miortvy viejerny mazgavy karał",
  "block.minecraft.dead_brain_coral_wall_fan": "Miortvy haryzantalny viejerny mazgavy karał",
  "block.minecraft.dead_bubble_coral": "Miortvy puzyrysty karał",
  "block.minecraft.dead_bubble_coral_block": "Błok miortvaha puzyrystaha karała",
  "block.minecraft.dead_bubble_coral_fan": "Miortvy viejerny puzyrysty karał",
  "block.minecraft.dead_bubble_coral_wall_fan": "Miortvy haryzantalny viejerny puzyrysty karał",
  "block.minecraft.dead_bush": "Miortvy kust",
  "block.minecraft.dead_fire_coral": "Miortvy ahnisty karał",
  "block.minecraft.dead_fire_coral_block": "Błok miortvaha ahnistaha karała",
  "block.minecraft.dead_fire_coral_fan": "Miortvy viejerny ahnisty karał",
  "block.minecraft.dead_fire_coral_wall_fan": "Miortvy haryzantalny viejerny ahnisty karał",
  "block.minecraft.dead_horn_coral": "Miortvy rahavy karał",
  "block.minecraft.dead_horn_coral_block": "Błok miortvaha rahavoha karała",
  "block.minecraft.dead_horn_coral_fan": "Miortvy viejerny rahavy karał",
  "block.minecraft.dead_horn_coral_wall_fan": "Miortvy haryzantalny viejerny rahavy karał",
  "block.minecraft.dead_tube_coral": "Miortvy trubčasty karał",
  "block.minecraft.dead_tube_coral_block": "Błok miortvaha trubčastaha karała",
  "block.minecraft.dead_tube_coral_fan": "Miortvy viejerny trubčasty karał",
  "block.minecraft.dead_tube_coral_wall_fan": "Miortvy haryzantalny viejerny trubčasty karał",
  "block.minecraft.decorated_pot": "Dekaratyŭny harščok",
  "block.minecraft.deepslate": "Słaniec",
  "block.minecraft.deepslate_brick_slab": "Plita sa słancavaj cegły",
  "block.minecraft.deepslate_brick_stairs": "Prystupki sa słancavaj cegły",
  "block.minecraft.deepslate_brick_wall": "Sciana sa słancavaj cegły",
  "block.minecraft.deepslate_bricks": "Słancavaja cegła",
  "block.minecraft.deepslate_coal_ore": "Vuhalnaja ruda hłybiń",
  "block.minecraft.deepslate_copper_ore": "Miadzianaja ruda hłybiń",
  "block.minecraft.deepslate_diamond_ore": "Dyjamientavaja ruda hłybiń",
  "block.minecraft.deepslate_emerald_ore": "Smarahdavaja ruda hłybiń",
  "block.minecraft.deepslate_gold_ore": "Załataja ruda hłybiń",
  "block.minecraft.deepslate_iron_ore": "Žaleznaja ruda hłybiń",
  "block.minecraft.deepslate_lapis_ore": "Łazurytavaja ruda hłybiń",
  "block.minecraft.deepslate_redstone_ore": "Redstonavaja ruda hłybiń",
  "block.minecraft.deepslate_tile_slab": "Plita sa słancavaj kafli",
  "block.minecraft.deepslate_tile_stairs": "Prystupki sa słancavaj kafli",
  "block.minecraft.deepslate_tile_wall": "Sciana sa słancavaj kafli",
  "block.minecraft.deepslate_tiles": "Słancavaja kafla",
  "block.minecraft.detector_rail": "Rejki z datčykam",
  "block.minecraft.diamond_block": "Dyjamientavy błok",
  "block.minecraft.diamond_ore": "Dyjamientavaja ruda",
  "block.minecraft.diorite": "Dyjaryt",
  "block.minecraft.diorite_slab": "Plita z dyjarytu",
  "block.minecraft.diorite_stairs": "Prystupki z dyjarytu",
  "block.minecraft.diorite_wall": "Sciana z dyjarytu",
  "block.minecraft.dirt": "Ziamla",
  "block.minecraft.dirt_path": "Sciežka",
  "block.minecraft.dispenser": "Razdavalnik",
  "block.minecraft.dragon_egg": "Jajka cmoka",
  "block.minecraft.dragon_head": "Hałava cmoka",
  "block.minecraft.dragon_wall_head": "Nasciennaja hałava cmoka",
  "block.minecraft.dried_ghast": "Zasmahły ghast",
  "block.minecraft.dried_kelp_block": "Błok sušanaj łaminaryi",
  "block.minecraft.dripstone_block": "Błok nacioku",
  "block.minecraft.dropper": "Vykidalnik",
  "block.minecraft.emerald_block": "Smarahdavy błok",
  "block.minecraft.emerald_ore": "Smarahdavaja ruda",
  "block.minecraft.enchanting_table": "Čaraŭnicki stoł",
  "block.minecraft.end_gateway": "Brama Enda",
  "block.minecraft.end_portal": "Partał u End",
  "block.minecraft.end_portal_frame": "Ramka partała ŭ End",
  "block.minecraft.end_rod": "Endar-stryžań",
  "block.minecraft.end_stone": "Kamień Enda",
  "block.minecraft.end_stone_brick_slab": "Plita z cegły Enda",
  "block.minecraft.end_stone_brick_stairs": "Prystupki z cegły Enda",
  "block.minecraft.end_stone_brick_wall": "Sciana z cegły z kamniu Enda",
  "block.minecraft.end_stone_bricks": "Cegła z kamniu Enda",
  "block.minecraft.ender_chest": "Ender-kufar",
  "block.minecraft.exposed_chiseled_copper": "Paćmianiełaja raźbianaja miedź",
  "block.minecraft.exposed_copper": "Paćmianiełaja miedź",
  "block.minecraft.exposed_copper_bars": "Paćmianiełyja miadzianyja kraty",
  "block.minecraft.exposed_copper_bulb": "Paćmianiełaja miadzianaja lampa",
  "block.minecraft.exposed_copper_chain": "Paćmianieły miadziany łancuh",
  "block.minecraft.exposed_copper_chest": "Paćmianieły miadziany kufar",
  "block.minecraft.exposed_copper_door": "Paćmianiełyja miadzianyja dzviery",
  "block.minecraft.exposed_copper_golem_statue": "Paćmianiełaja statuja miadzianaha holema",
  "block.minecraft.exposed_copper_grate": "Paćmianiełaja miadzianaja rašotka",
  "block.minecraft.exposed_copper_lantern": "Paćmianieły miadziany lichtar",
  "block.minecraft.exposed_copper_trapdoor": "Paćmianieły miadziany luk",
  "block.minecraft.exposed_cut_copper": "Paćmianiełaja raznaja miedź",
  "block.minecraft.exposed_cut_copper_slab": "Paćmianiełaja plita z raznoj miedzi",
  "block.minecraft.exposed_cut_copper_stairs": "Paćmianiełyja prystupki z raznoj miedzi",
  "block.minecraft.exposed_lightning_rod": "Paćmianieły małankaadvod",
  "block.minecraft.farmland": "Ralla",
  "block.minecraft.fern": "Paparać",
  "block.minecraft.fire": "Ahoń",
  "block.minecraft.fire_coral": "Ahnisty karał",
  "block.minecraft.fire_coral_block": "Błok ahnistaha karała",
  "block.minecraft.fire_coral_fan": "Viejerny ahnisty karał",
  "block.minecraft.fire_coral_wall_fan": "Haryzantalny viejerny ahnisty karał",
  "block.minecraft.firefly_bush": "Svietlačkovy kust",
  "block.minecraft.fletching_table": "Varštat łučnika",
  "block.minecraft.flower_pot": "Harščok",
  "block.minecraft.flowering_azalea": "Kvitniejučaja azalija",
  "block.minecraft.flowering_azalea_leaves": "Liscie kvitniejučaj azalii",
  "block.minecraft.frogspawn": "Žaburynnie",
  "block.minecraft.frosted_ice": "Tały lod",
  "block.minecraft.furnace": "Pieč",
  "block.minecraft.gilded_blackstone": "Pazałočany čarnit",
  "block.minecraft.glass": "Škło",
  "block.minecraft.glass_pane": "Šyba",
  "block.minecraft.glow_lichen": "Zichatlivy lišajnik",
  "block.minecraft.glowstone": "Zichatlivy kamień",
  "block.minecraft.gold_block": "Załaty błok",
  "block.minecraft.gold_ore": "Załataja ruda",
  "block.minecraft.golden_dandelion": "Załaty dźmuchaviec",
  "block.minecraft.granite": "Hranit",
  "block.minecraft.granite_slab": "Plita z hranitu",
  "block.minecraft.granite_stairs": "Prystupki z hranitu",
  "block.minecraft.granite_wall": "Sciana z hranitu",
  "block.minecraft.grass": "Trava",
  "block.minecraft.grass_block": "Ziamla z dziornam",
  "block.minecraft.gravel": "Žvir",
  "block.minecraft.gray_banner": "Šery sciah",
  "block.minecraft.gray_bed": "Šery łožak",
  "block.minecraft.gray_candle": "Šeraja sviečka",
  "block.minecraft.gray_candle_cake": "Tort z šeraj sviečkaj",
  "block.minecraft.gray_carpet": "Šery dyvan",
  "block.minecraft.gray_concrete": "Šery bieton",
  "block.minecraft.gray_concrete_powder": "Šery cemient",
  "block.minecraft.gray_glazed_terracotta": "Šeraja palivanaja kieramika",
  "block.minecraft.gray_shulker_box": "Šeraja shulkeravaja skrynia",
  "block.minecraft.gray_stained_glass": "Šeraje škło",
  "block.minecraft.gray_stained_glass_pane": "Šeraja šyba",
  "block.minecraft.gray_terracotta": "Šeraja kieramika",
  "block.minecraft.gray_wool": "Šeraja voŭna",
  "block.minecraft.green_banner": "Zialony sciah",
  "block.minecraft.green_bed": "Zialony łožak",
  "block.minecraft.green_candle": "Zialonaja sviečka",
  "block.minecraft.green_candle_cake": "Tort z zialonaj sviečkaj",
  "block.minecraft.green_carpet": "Zialony dyvan",
  "block.minecraft.green_concrete": "Zialony bieton",
  "block.minecraft.green_concrete_powder": "Zialony cemient",
  "block.minecraft.green_glazed_terracotta": "Zialonaja palivanaja kieramika",
  "block.minecraft.green_shulker_box": "Zialonaja shulkeravaja skrynia",
  "block.minecraft.green_stained_glass": "Zialonaje škło",
  "block.minecraft.green_stained_glass_pane": "Zialonaja šyba",
  "block.minecraft.green_terracotta": "Zialonaja kieramika",
  "block.minecraft.green_wool": "Zialonaja voŭna",
  "block.minecraft.grindstone": "Šlifavalny kruh",
  "block.minecraft.hanging_roots": "Visiačyja karani",
  "block.minecraft.hay_block": "Ciuk siena",
  "block.minecraft.heavy_core": "Važkaje jadro",
  "block.minecraft.heavy_weighted_pressure_plate": "Vahavaja nacisknaja plita (ciažkaja)",
  "block.minecraft.honey_block": "Błok miodu",
  "block.minecraft.honeycomb_block": "Błok miadovych sotaŭ",
  "block.minecraft.hopper": "Varonka",
  "block.minecraft.horn_coral": "Rahavy karał",
  "block.minecraft.horn_coral_block": "Błok rahavoha karała",
  "block.minecraft.horn_coral_fan": "Viejerny rahavy karał",
  "block.minecraft.horn_coral_wall_fan": "Haryzantalny viejerny rahavy karał",
  "block.minecraft.ice": "Lod",
  "block.minecraft.infested_chiseled_stone_bricks": "Zaražanaja raźbianaja kamiennaja cegła",
  "block.minecraft.infested_cobblestone": "Zaražany but",
  "block.minecraft.infested_cracked_stone_bricks": "Zaražanaja patreskanaja kamiennaja cegła",
  "block.minecraft.infested_deepslate": "Zaražany słaniec",
  "block.minecraft.infested_mossy_stone_bricks": "Zaražanaja zamšełaja kamiennaja cegła",
  "block.minecraft.infested_stone": "Zaražany kamień",
  "block.minecraft.infested_stone_bricks": "Zaražanaja kamiennaja cegła",
  "block.minecraft.iron_bars": "Žaleznyja kraty",
  "block.minecraft.iron_block": "Žalezny błok",
  "block.minecraft.iron_chain": "Žalezny łancuh",
  "block.minecraft.iron_door": "Žaleznyja dzviery",
  "block.minecraft.iron_ore": "Žaleznaja ruda",
  "block.minecraft.iron_trapdoor": "Žalezny luk",
  "block.minecraft.jack_o_lantern": "Sviacilnia Džeka",
  "block.minecraft.jigsaw": "Kanstrukcyjny błok",
  "block.minecraft.jukebox": "Prajhravalnik",
  "block.minecraft.jungle_button": "Knopka z trapičnaj draŭniny",
  "block.minecraft.jungle_door": "Dzviery z trapičnaj draŭniny",
  "block.minecraft.jungle_fence": "Płot z trapičnaj draŭniny",
  "block.minecraft.jungle_fence_gate": "Bramka z trapičnaj draŭniny",
  "block.minecraft.jungle_hanging_sign": "Padviesnaja šylda z trapičnaj draŭniny",
  "block.minecraft.jungle_leaves": "Trapičnaje liscie",
  "block.minecraft.jungle_log": "Bierviano z trapičnaha dreva",
  "block.minecraft.jungle_planks": "Doški z trapičnaj draŭniny",
  "block.minecraft.jungle_pressure_plate": "Nacisknaja plita z trapičnaj draŭniny",
  "block.minecraft.jungle_sapling": "Sadžaniec trapičnaha dreva",
  "block.minecraft.jungle_shelf": "Palica z trapičnaj draŭniny",
  "block.minecraft.jungle_sign": "Šylda z trapičnaj draŭniny",
  "block.minecraft.jungle_slab": "Plita z trapičnaj draŭniny",
  "block.minecraft.jungle_stairs": "Prystupki z trapičnaj draŭniny",
  "block.minecraft.jungle_trapdoor": "Luk z trapičnaj draŭniny",
  "block.minecraft.jungle_wall_hanging_sign": "Nasciennaja padviesnaja šylda z trapičnaj draŭniny",
  "block.minecraft.jungle_wall_sign": "Nasciennaja šylda z trapičnaj draŭniny",
  "block.minecraft.jungle_wood": "Trapičnaja draŭnina",
  "block.minecraft.kelp": "Łaminaryja",
  "block.minecraft.kelp_plant": "Sciabło łaminaryi",
  "block.minecraft.ladder": "Lesvica",
  "block.minecraft.lantern": "Lichtar",
  "block.minecraft.lapis_block": "Łazurytavy błok",
  "block.minecraft.lapis_ore": "Łazurytavaja ruda",
  "block.minecraft.large_amethyst_bud": "Vialiki zarodak amietystu",
  "block.minecraft.large_fern": "Vialikaja paparać",
  "block.minecraft.lava": "Łava",
  "block.minecraft.lava_cauldron": "Kacioł łavy",
  "block.minecraft.leaf_litter": "Suchoje liscie",
  "block.minecraft.lectern": "Kafiedra",
  "block.minecraft.lever": "Ryčah",
  "block.minecraft.light": "Sviatło",
  "block.minecraft.light_blue_banner": "Błakitny sciah",
  "block.minecraft.light_blue_bed": "Błakitny łožak",
  "block.minecraft.light_blue_candle": "Błakitnaja sviečka",
  "block.minecraft.light_blue_candle_cake": "Tort z błakitnaj sviečkaj",
  "block.minecraft.light_blue_carpet": "Błakitny dyvan",
  "block.minecraft.light_blue_concrete": "Błakitny bieton",
  "block.minecraft.light_blue_concrete_powder": "Błakitny cemient",
  "block.minecraft.light_blue_glazed_terracotta": "Błakitnaja palivanaja kieramika",
  "block.minecraft.light_blue_shulker_box": "Błakitnaja shulkeravaja skrynia",
  "block.minecraft.light_blue_stained_glass": "Błakitnaje škło",
  "block.minecraft.light_blue_stained_glass_pane": "Błakitnaja šyba",
  "block.minecraft.light_blue_terracotta": "Błakitnaja kieramika",
  "block.minecraft.light_blue_wool": "Błakitnaja voŭna",
  "block.minecraft.light_gray_banner": "Svietła-šery sciah",
  "block.minecraft.light_gray_bed": "Svietła-šery łožak",
  "block.minecraft.light_gray_candle": "Svietła-šeraja sviečka",
  "block.minecraft.light_gray_candle_cake": "Tort z svietła-šeraj sviečkaj",
  "block.minecraft.light_gray_carpet": "Svietła-šery dyvan",
  "block.minecraft.light_gray_concrete": "Svietła-šery bieton",
  "block.minecraft.light_gray_concrete_powder": "Svietła-šery cemient",
  "block.minecraft.light_gray_glazed_terracotta": "Svietła-šeraja palivanaja kieramika",
  "block.minecraft.light_gray_shulker_box": "Svietła-šeraja shulkeravaja skrynia",
  "block.minecraft.light_gray_stained_glass": "Svietła-šeraje škło",
  "block.minecraft.light_gray_stained_glass_pane": "Svietła-šeraja šyba",
  "block.minecraft.light_gray_terracotta": "Svietła-šeraja kieramika",
  "block.minecraft.light_gray_wool": "Svietła-šeraja voŭna",
  "block.minecraft.light_weighted_pressure_plate": "Vahavaja nacisknaja plita (lohkaja)",
  "block.minecraft.lightning_rod": "Małankaadvod",
  "block.minecraft.lilac": "Bez",
  "block.minecraft.lily_of_the_valley": "Łandyš",
  "block.minecraft.lily_pad": "Harłačyk",
  "block.minecraft.lime_banner": "Łajmavy sciah",
  "block.minecraft.lime_bed": "Łajmavy łožak",
  "block.minecraft.lime_candle": "Łajmavaja sviečka",
  "block.minecraft.lime_candle_cake": "Tort z łajmavaj sviečkaj",
  "block.minecraft.lime_carpet": "Łajmavy dyvan",
  "block.minecraft.lime_concrete": "Łajmavy bieton",
  "block.minecraft.lime_concrete_powder": "Łajmavy cemient",
  "block.minecraft.lime_glazed_terracotta": "Łajmavaja palivanaja kieramika",
  "block.minecraft.lime_shulker_box": "Łajmavaja shulkeravaja skrynia",
  "block.minecraft.lime_stained_glass": "Łajmavaje škło",
  "block.minecraft.lime_stained_glass_pane": "Łajmavaja šyba",
  "block.minecraft.lime_terracotta": "Łajmavaja kieramika",
  "block.minecraft.lime_wool": "Łajmavaja voŭna",
  "block.minecraft.lodestone": "Mahnietyt",
  "block.minecraft.loom": "Krosny",
  "block.minecraft.magenta_banner": "Purpurny sciah",
  "block.minecraft.magenta_bed": "Purpurny łožak",
  "block.minecraft.magenta_candle": "Purpurnaja sviečka",
  "block.minecraft.magenta_candle_cake": "Tort z purpurnaj sviečkaj",
  "block.minecraft.magenta_carpet": "Purpurny dyvan",
  "block.minecraft.magenta_concrete": "Purpurny bieton",
  "block.minecraft.magenta_concrete_powder": "Purpurny cemient",
  "block.minecraft.magenta_glazed_terracotta": "Purpurnaja palivanaja kieramika",
  "block.minecraft.magenta_shulker_box": "Purpurnaja shulkeravaja skrynia",
  "block.minecraft.magenta_stained_glass": "Purpurnaje škło",
  "block.minecraft.magenta_stained_glass_pane": "Purpurnaja šyba",
  "block.minecraft.magenta_terracotta": "Purpurnaja kieramika",
  "block.minecraft.magenta_wool": "Purpurnaja voŭna",
  "block.minecraft.magma_block": "Mahma",
  "block.minecraft.mangrove_button": "Knopka z manhravaj draŭniny",
  "block.minecraft.mangrove_door": "Dzviery z manhravaj draŭniny",
  "block.minecraft.mangrove_fence": "Płot z manhravaj draŭniny",
  "block.minecraft.mangrove_fence_gate": "Bramka z manhravaj draŭniny",
  "block.minecraft.mangrove_hanging_sign": "Padviesnaja šylda z manhravaj draŭniny",
  "block.minecraft.mangrove_leaves": "Manhravaje liscie",
  "block.minecraft.mangrove_log": "Manhravaje bierviano",
  "block.minecraft.mangrove_planks": "Doški z manhravaj draŭniny",
  "block.minecraft.mangrove_pressure_plate": "Nacisknaja plita z manhravaj draŭniny",
  "block.minecraft.mangrove_propagule": "Manhravaja prapahuła",
  "block.minecraft.mangrove_roots": "Karani manhravaha dreva",
  "block.minecraft.mangrove_shelf": "Palica z manhravaj draŭniny",
  "block.minecraft.mangrove_sign": "Šylda z manhravaj draŭniny",
  "block.minecraft.mangrove_slab": "Plita z manhravaj draŭniny",
  "block.minecraft.mangrove_stairs": "Prystupki z manhravaj draŭniny",
  "block.minecraft.mangrove_trapdoor": "Luk z manhravaj draŭniny",
  "block.minecraft.mangrove_wall_hanging_sign": "Nasciennaja padviesnaja šylda z manhravaj draŭniny",
  "block.minecraft.mangrove_wall_sign": "Nasciennaja šylda z manhravaj draŭniny",
  "block.minecraft.mangrove_wood": "Manhravaja draŭnina",
  "block.minecraft.medium_amethyst_bud": "Siaredni zarodak amietystu",
  "block.minecraft.melon": "Kavun",
  "block.minecraft.melon_stem": "Sciabło kavuna",
  "block.minecraft.moss_block": "Błok imchu",
  "block.minecraft.moss_carpet": "Imchovy dyvan",
  "block.minecraft.mossy_cobblestone": "Zamšeły but",
  "block.minecraft.mossy_cobblestone_slab": "Zamšełaja plita z butu",
  "block.minecraft.mossy_cobblestone_stairs": "Zamšełyja prystupki z butu",
  "block.minecraft.mossy_cobblestone_wall": "Sciana z zamšełaha butu",
  "block.minecraft.mossy_stone_brick_slab": "Zamšełaja plita z kamiennaj cegły",
  "block.minecraft.mossy_stone_brick_stairs": "Zamšełyja prystupki z kamiennaj cegły",
  "block.minecraft.mossy_stone_brick_wall": "Zamšełaja sciana z kamiennaj cegły",
  "block.minecraft.mossy_stone_bricks": "Zamšełaja kamiennaja cegła",
  "block.minecraft.moving_piston": "Poršań u ruchu",
  "block.minecraft.mud": "Hraź",
  "block.minecraft.mud_brick_slab": "Plita z samanavaj cegły",
  "block.minecraft.mud_brick_stairs": "Prystupki z samanavaj cegły",
  "block.minecraft.mud_brick_wall": "Sciana z samanavaj cegły",
  "block.minecraft.mud_bricks": "Samanavaja cegła",
  "block.minecraft.muddy_mangrove_roots": "Hrazkija karani manhravaha dreva",
  "block.minecraft.mushroom_stem": "Nožka hryba",
  "block.minecraft.mycelium": "Micelij",
  "block.minecraft.nether_brick_fence": "Płot z netherskaj cegły",
  "block.minecraft.nether_brick_slab": "Plita z netherskaj cegły",
  "block.minecraft.nether_brick_stairs": "Prystupki z netherskaj cegły",
  "block.minecraft.nether_brick_wall": "Sciana z netherskaj cegły",
  "block.minecraft.nether_bricks": "Netherskaja cegła",
  "block.minecraft.nether_gold_ore": "Netherskaja zalataja ruda",
  "block.minecraft.nether_portal": "Partał u Nether",
  "block.minecraft.nether_quartz_ore": "Kvarcavaja ruda",
  "block.minecraft.nether_sprouts": "Netherskija parastki",
  "block.minecraft.nether_wart": "Netherskaja narasć",
  "block.minecraft.nether_wart_block": "Błok netherskaj narasci",
  "block.minecraft.netherite_block": "Netherytavy błok",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Notny błok",
  "block.minecraft.oak_button": "Dubovaja knopka",
  "block.minecraft.oak_door": "Dubovyja dzviery",
  "block.minecraft.oak_fence": "Dubovy płot",
  "block.minecraft.oak_fence_gate": "Dubovaja bramka",
  "block.minecraft.oak_hanging_sign": "Dubovaja padviesnaja šylda",
  "block.minecraft.oak_leaves": "Dubovaje liscie",
  "block.minecraft.oak_log": "Dubovaje bierviano",
  "block.minecraft.oak_planks": "Dubovyja doški",
  "block.minecraft.oak_pressure_plate": "Dubovaja nacisknaja plita",
  "block.minecraft.oak_sapling": "Sadžaniec duba",
  "block.minecraft.oak_shelf": "Dubovaja palica",
  "block.minecraft.oak_sign": "Dubovaja šylda",
  "block.minecraft.oak_slab": "Dubovaja plita",
  "block.minecraft.oak_stairs": "Dubovyja prystupki",
  "block.minecraft.oak_trapdoor": "Dubovy luk",
  "block.minecraft.oak_wall_hanging_sign": "Dubovaja nasciennaja padviesnaja šylda",
  "block.minecraft.oak_wall_sign": "Dubovaja nasciennaja šylda",
  "block.minecraft.oak_wood": "Dubovaja draŭnina",
  "block.minecraft.observer": "Naziralnik",
  "block.minecraft.obsidian": "Absidyjan",
  "block.minecraft.ochre_froglight": "Vochravaje žabinaje sviatło",
  "block.minecraft.ominous_banner": "Złaviesny sciah",
  "block.minecraft.open_eyeblossom": "Adkryty vokacviet",
  "block.minecraft.orange_banner": "Aranžavy sciah",
  "block.minecraft.orange_bed": "Aranžavy łožak",
  "block.minecraft.orange_candle": "Aranžavaja sviečka",
  "block.minecraft.orange_candle_cake": "Tort z aranžavaj sviečkaj",
  "block.minecraft.orange_carpet": "Aranžavy dyvan",
  "block.minecraft.orange_concrete": "Aranžavy bieton",
  "block.minecraft.orange_concrete_powder": "Aranžavy cemient",
  "block.minecraft.orange_glazed_terracotta": "Aranžavaja palivanaja kieramika",
  "block.minecraft.orange_shulker_box": "Aranžavaja shulkeravaja skrynia",
  "block.minecraft.orange_stained_glass": "Aranžavaje škło",
  "block.minecraft.orange_stained_glass_pane": "Aranžavaja šyba",
  "block.minecraft.orange_terracotta": "Aranžavaja kieramika",
  "block.minecraft.orange_tulip": "Aranžavy ciulpan",
  "block.minecraft.orange_wool": "Aranžavaja voŭna",
  "block.minecraft.oxeye_daisy": "Ciuciupan",
  "block.minecraft.oxidized_chiseled_copper": "Akislenaja raźbianaja miedź",
  "block.minecraft.oxidized_copper": "Akislenaja miedź",
  "block.minecraft.oxidized_copper_bars": "Akislenyja miadzianyja kraty",
  "block.minecraft.oxidized_copper_bulb": "Akislenaja miadzianaja lampa",
  "block.minecraft.oxidized_copper_chain": "Akisleny miadziany łancuh",
  "block.minecraft.oxidized_copper_chest": "Akisleny miadziany kufar",
  "block.minecraft.oxidized_copper_door": "Akislenyja miadzianyja dzviery",
  "block.minecraft.oxidized_copper_golem_statue": "Akislenaja statuja miadzianaha holema",
  "block.minecraft.oxidized_copper_grate": "Akislenaja miadzianaja rašotka",
  "block.minecraft.oxidized_copper_lantern": "Akisleny miadziany lichtar",
  "block.minecraft.oxidized_copper_trapdoor": "Akisleny miadziany luk",
  "block.minecraft.oxidized_cut_copper": "Akislenaja raznaja miedź",
  "block.minecraft.oxidized_cut_copper_slab": "Akislenaja plita z raznoj miedzi",
  "block.minecraft.oxidized_cut_copper_stairs": "Akislenyja prystupki z raznoj miedzi",
  "block.minecraft.oxidized_lightning_rod": "Akisleny małankaadvod",
  "block.minecraft.packed_ice": "Ščylny lod",
  "block.minecraft.packed_mud": "Ščylnaja hraź",
  "block.minecraft.pale_hanging_moss": "Bledny visiačy moch",
  "block.minecraft.pale_moss_block": "Błok blednaha imchu",
  "block.minecraft.pale_moss_carpet": "Bledny imchovy dyvan",
  "block.minecraft.pale_oak_button": "Knopka z blednaha dubu",
  "block.minecraft.pale_oak_door": "Dzviery z blednaha dubu",
  "block.minecraft.pale_oak_fence": "Płot z blednaha dubu",
  "block.minecraft.pale_oak_fence_gate": "Bramka z blednaha dubu",
  "block.minecraft.pale_oak_hanging_sign": "Padviesnaja šylda z blednaha dubu",
  "block.minecraft.pale_oak_leaves": "Liscie blednaha duba",
  "block.minecraft.pale_oak_log": "Bierviano z blednaha dubu",
  "block.minecraft.pale_oak_planks": "Doški z blednaha dubu",
  "block.minecraft.pale_oak_pressure_plate": "Nacisknaja plita z blednaha dubu",
  "block.minecraft.pale_oak_sapling": "Sadžaniec blednaha duba",
  "block.minecraft.pale_oak_shelf": "Palica z blednaha dubu",
  "block.minecraft.pale_oak_sign": "Šylda z blednaha dubu",
  "block.minecraft.pale_oak_slab": "Plita z blednaha dubu",
  "block.minecraft.pale_oak_stairs": "Prystupki z blednaha dubu",
  "block.minecraft.pale_oak_trapdoor": "Luk z blednaha dubu",
  "block.minecraft.pale_oak_wall_hanging_sign": "Nasciennaja padviesnaja šylda z blednaha dubu",
  "block.minecraft.pale_oak_wall_sign": "Nasciennaja šylda z blednaha dubu",
  "block.minecraft.pale_oak_wood": "Draŭnina blednaha duba",
  "block.minecraft.pearlescent_froglight": "Pierłamutravaje žabinaje sviatło",
  "block.minecraft.peony": "Pivonia",
  "block.minecraft.petrified_oak_slab": "Akamianiełaja dubovaja plita",
  "block.minecraft.piglin_head": "Hałava piglina",
  "block.minecraft.piglin_wall_head": "Nasciennaja hałava piglina",
  "block.minecraft.pink_banner": "Ružovy sciah",
  "block.minecraft.pink_bed": "Ružovy łožak",
  "block.minecraft.pink_candle": "Ružovaja sviečka",
  "block.minecraft.pink_candle_cake": "Tort z ružovaj sviečkaj",
  "block.minecraft.pink_carpet": "Ružovy dyvan",
  "block.minecraft.pink_concrete": "Ružovy bieton",
  "block.minecraft.pink_concrete_powder": "Ružovy cemient",
  "block.minecraft.pink_glazed_terracotta": "Ružovaja palivanaja kieramika",
  "block.minecraft.pink_petals": "Ružovyja pialostki",
  "block.minecraft.pink_shulker_box": "Ružovaja shulkeravaja skrynia",
  "block.minecraft.pink_stained_glass": "Ružovaje škło",
  "block.minecraft.pink_stained_glass_pane": "Ružovaja šyba",
  "block.minecraft.pink_terracotta": "Ružovaja kieramika",
  "block.minecraft.pink_tulip": "Ružovy ciulpan",
  "block.minecraft.pink_wool": "Ružovaja voŭna",
  "block.minecraft.piston": "Poršań",
  "block.minecraft.piston_head": "Pavierchnia poršnia",
  "block.minecraft.pitcher_crop": "Parastak hładyšnika",
  "block.minecraft.pitcher_plant": "Hładyšnik",
  "block.minecraft.player_head": "Hałava hulca",
  "block.minecraft.player_head.named": "Hałava %s",
  "block.minecraft.player_wall_head": "Nasciennaja hałava hulca",
  "block.minecraft.podzol": "Padzoł",
  "block.minecraft.pointed_dripstone": "Zavostrany naciok",
  "block.minecraft.polished_andesite": "Paliravany andezit",
  "block.minecraft.polished_andesite_slab": "Plita z paliravanaha andezitu",
  "block.minecraft.polished_andesite_stairs": "Prystupki z paliravanaha andezitu",
  "block.minecraft.polished_basalt": "Paliravany bazalt",
  "block.minecraft.polished_blackstone": "Paliravany čarnit",
  "block.minecraft.polished_blackstone_brick_slab": "Plita z paliravanaj čarnitavaj cegły",
  "block.minecraft.polished_blackstone_brick_stairs": "Prystupki z paliravanaj čarnitavaj cegły",
  "block.minecraft.polished_blackstone_brick_wall": "Sciana z paliravanaj čarnitavaj cegły",
  "block.minecraft.polished_blackstone_bricks": "Cegła z paliravanaha čarnitu",
  "block.minecraft.polished_blackstone_button": "Paliravanaja knopka z čarnitu",
  "block.minecraft.polished_blackstone_pressure_plate": "Nacisknaja plita z paliravanaha čarnitu",
  "block.minecraft.polished_blackstone_slab": "Plita z paliravanaha čarnitu",
  "block.minecraft.polished_blackstone_stairs": "Prystupki z paliravanaha čarnitu",
  "block.minecraft.polished_blackstone_wall": "Sciana z paliravanaha čarnitu",
  "block.minecraft.polished_deepslate": "Paliravany słaniec",
  "block.minecraft.polished_deepslate_slab": "Plita z paliravanaha słancu",
  "block.minecraft.polished_deepslate_stairs": "Prystupki z paliravanaha słancu",
  "block.minecraft.polished_deepslate_wall": "Sciana z paliravanaha słancu",
  "block.minecraft.polished_diorite": "Paliravany dyjaryt",
  "block.minecraft.polished_diorite_slab": "Plita z paliravanaha dyjarytu",
  "block.minecraft.polished_diorite_stairs": "Prystupki z paliravanaha dyjarytu",
  "block.minecraft.polished_granite": "Paliravany hranit",
  "block.minecraft.polished_granite_slab": "Plita z paliravanaha hranitu",
  "block.minecraft.polished_granite_stairs": "Prystupki z paliravanaha hranitu",
  "block.minecraft.polished_tuff": "Paliravany tuf",
  "block.minecraft.polished_tuff_slab": "Plita z paliravanaha tufu",
  "block.minecraft.polished_tuff_stairs": "Prystupki z paliravanaha tufu",
  "block.minecraft.polished_tuff_wall": "Sciana z paliravanaha tufu",
  "block.minecraft.poppy": "Mak",
  "block.minecraft.potatoes": "Bulba",
  "block.minecraft.potted_acacia_sapling": "Sadžaniec akacyi ŭ haršku",
  "block.minecraft.potted_allium": "Cybula ŭ haršku",
  "block.minecraft.potted_azalea_bush": "Azalija ŭ haršku",
  "block.minecraft.potted_azure_bluet": "Chaŭstonija błakitnaja ŭ haršku",
  "block.minecraft.potted_bamboo": "Bambuk u haršku",
  "block.minecraft.potted_birch_sapling": "Sadžaniec biarozy ŭ haršku",
  "block.minecraft.potted_blue_orchid": "Błakitnaja archideja ŭ haršku",
  "block.minecraft.potted_brown_mushroom": "Baravik u haršku",
  "block.minecraft.potted_cactus": "Kaktus u haršku",
  "block.minecraft.potted_cherry_sapling": "Sadžaniec višni ŭ haršku",
  "block.minecraft.potted_closed_eyeblossom": "Zakryty vokacviet u haršku",
  "block.minecraft.potted_cornflower": "Vałoška ŭ haršku",
  "block.minecraft.potted_crimson_fungus": "Barvovy hryb u haršku",
  "block.minecraft.potted_crimson_roots": "Barvovyja karani ŭ haršku",
  "block.minecraft.potted_dandelion": "Dźmuchaviec u haršku",
  "block.minecraft.potted_dark_oak_sapling": "Sadžaniec ciomnaha duba ŭ haršku",
  "block.minecraft.potted_dead_bush": "Miortvy kust u haršku",
  "block.minecraft.potted_fern": "Paparać u haršku",
  "block.minecraft.potted_flowering_azalea_bush": "Kvitniejučaja azalija ŭ haršku",
  "block.minecraft.potted_golden_dandelion": "Załaty dźmuchaviec u haršku",
  "block.minecraft.potted_jungle_sapling": "Sadžaniec trapičnaha dreva ŭ haršku",
  "block.minecraft.potted_lily_of_the_valley": "Łandyš u haršku",
  "block.minecraft.potted_mangrove_propagule": "Manhravaja prapahuła ŭ haršku",
  "block.minecraft.potted_oak_sapling": "Sadžaniec duba ŭ haršku",
  "block.minecraft.potted_open_eyeblossom": "Adkryty vokacviet u haršku",
  "block.minecraft.potted_orange_tulip": "Aranžavy ciulpan u haršku",
  "block.minecraft.potted_oxeye_daisy": "Ciuciupan u haršku",
  "block.minecraft.potted_pale_oak_sapling": "Sadžaniec blednaha duba ŭ haršku",
  "block.minecraft.potted_pink_tulip": "Ružovy ciulpan u haršku",
  "block.minecraft.potted_poppy": "Mak u haršku",
  "block.minecraft.potted_red_mushroom": "Muchamor u haršku",
  "block.minecraft.potted_red_tulip": "Čyrvony ciulpan u haršku",
  "block.minecraft.potted_spruce_sapling": "Sadžaniec jełki ŭ haršku",
  "block.minecraft.potted_torchflower": "Pałymianaja lileja ŭ haršku",
  "block.minecraft.potted_warped_fungus": "Skažony hryb u haršku",
  "block.minecraft.potted_warped_roots": "Skažonyja karani ŭ haršku",
  "block.minecraft.potted_white_tulip": "Bieły ciulpan u haršku",
  "block.minecraft.potted_wither_rose": "Ruža withera ŭ haršku",
  "block.minecraft.powder_snow": "Sypki snieh",
  "block.minecraft.powder_snow_cauldron": "Kacioł sypkaha sniehu",
  "block.minecraft.powered_rail": "Enierharejki",
  "block.minecraft.prismarine": "Pryzmaryn",
  "block.minecraft.prismarine_brick_slab": "Plita z pryzmarynavaj cegły",
  "block.minecraft.prismarine_brick_stairs": "Prystupki z pryzmarynavaj cegły",
  "block.minecraft.prismarine_bricks": "Pryzmarynavaja cegła",
  "block.minecraft.prismarine_slab": "Plita z pryzmarynu",
  "block.minecraft.prismarine_stairs": "Pryzmarynavyja prystupki",
  "block.minecraft.prismarine_wall": "Sciana z pryzmarynu",
  "block.minecraft.pumpkin": "Harbuz",
  "block.minecraft.pumpkin_stem": "Sciabło harbuza",
  "block.minecraft.purple_banner": "Fijaletavy sciah",
  "block.minecraft.purple_bed": "Fijaletavy łožak",
  "block.minecraft.purple_candle": "Fijaletavaja sviečka",
  "block.minecraft.purple_candle_cake": "Tort z fijaletavaj sviečkaj",
  "block.minecraft.purple_carpet": "Fijaletavy dyvan",
  "block.minecraft.purple_concrete": "Fijaletavy bieton",
  "block.minecraft.purple_concrete_powder": "Fijaletavy cemient",
  "block.minecraft.purple_glazed_terracotta": "Fijaletavaja palivanaja kieramika",
  "block.minecraft.purple_shulker_box": "Fijaletavaja shulkeravaja skrynia",
  "block.minecraft.purple_stained_glass": "Fijaletavaje škło",
  "block.minecraft.purple_stained_glass_pane": "Fijaletavaja šyba",
  "block.minecraft.purple_terracotta": "Fijaletavaja kieramika",
  "block.minecraft.purple_wool": "Fijaletavaja voŭna",
  "block.minecraft.purpur_block": "Błok purpuru",
  "block.minecraft.purpur_pillar": "Purpurovaja kałona",
  "block.minecraft.purpur_slab": "Purpurovaja plita",
  "block.minecraft.purpur_stairs": "Purpurovyja prystupki",
  "block.minecraft.quartz_block": "Kvarcavy błok",
  "block.minecraft.quartz_bricks": "Kvarcavaja cegła",
  "block.minecraft.quartz_pillar": "Kvarcavaja kałona",
  "block.minecraft.quartz_slab": "Kvarcavaja plita",
  "block.minecraft.quartz_stairs": "Kvarcavyja prystupki",
  "block.minecraft.rail": "Rejki",
  "block.minecraft.raw_copper_block": "Błok syroj miedzi",
  "block.minecraft.raw_gold_block": "Błok syroha zołata",
  "block.minecraft.raw_iron_block": "Błok syroha žaleza",
  "block.minecraft.red_banner": "Čyrvony sciah",
  "block.minecraft.red_bed": "Čyrvony łožak",
  "block.minecraft.red_candle": "Čyrvonaja sviečka",
  "block.minecraft.red_candle_cake": "Tort z čyrvonaj sviečkaj",
  "block.minecraft.red_carpet": "Čyrvony dyvan",
  "block.minecraft.red_concrete": "Čyrvony bieton",
  "block.minecraft.red_concrete_powder": "Čyrvony cemient",
  "block.minecraft.red_glazed_terracotta": "Čyrvonaja palivanaja kieramika",
  "block.minecraft.red_mushroom": "Muchamor",
  "block.minecraft.red_mushroom_block": "Błok muchamora",
  "block.minecraft.red_nether_brick_slab": "Plita z čyrvonaj netherskaj cegły",
  "block.minecraft.red_nether_brick_stairs": "Prystupki z čyrvonaj netherskaj cegły",
  "block.minecraft.red_nether_brick_wall": "Sciana z čyrvonaj netherskaj cegły",
  "block.minecraft.red_nether_bricks": "Čyrvonaja netherskaja cegła",
  "block.minecraft.red_sand": "Čyrvony piasok",
  "block.minecraft.red_sandstone": "Čyrvony piasčanik",
  "block.minecraft.red_sandstone_slab": "Plita z čyrvonaha piasčaniku",
  "block.minecraft.red_sandstone_stairs": "Prystupki z čyrvonaha piasčaniku",
  "block.minecraft.red_sandstone_wall": "Sciana z čyrvonaha piasčaniku",
  "block.minecraft.red_shulker_box": "Čyrvonaja shulkeravaja skrynia",
  "block.minecraft.red_stained_glass": "Čyrvonaje škło",
  "block.minecraft.red_stained_glass_pane": "Čyrvonaja šyba",
  "block.minecraft.red_terracotta": "Čyrvonaja kieramika",
  "block.minecraft.red_tulip": "Čyrvony ciulpan",
  "block.minecraft.red_wool": "Čyrvonaja voŭna",
  "block.minecraft.redstone_block": "Błok redstonu",
  "block.minecraft.redstone_lamp": "Redstonavaja lampa",
  "block.minecraft.redstone_ore": "Redstonavaja ruda",
  "block.minecraft.redstone_torch": "Redstonavy fakieł",
  "block.minecraft.redstone_wall_torch": "Nascienny redstonavy fakieł",
  "block.minecraft.redstone_wire": "Redstonavy provad",
  "block.minecraft.reinforced_deepslate": "Uzmocnieny słaniec",
  "block.minecraft.repeater": "Paŭtaralnik",
  "block.minecraft.repeating_command_block": "Paŭtorny kamandny błok",
  "block.minecraft.resin_block": "Smalany błok",
  "block.minecraft.resin_brick_slab": "Plita sa smalanoj cegły",
  "block.minecraft.resin_brick_stairs": "Prystupki sa smalanoj cegły",
  "block.minecraft.resin_brick_wall": "Sciana sa smalanoj cegły",
  "block.minecraft.resin_bricks": "Smalanaja cegła",
  "block.minecraft.resin_clump": "Zhustak smały",
  "block.minecraft.respawn_anchor": "Kotva adradžennia",
  "block.minecraft.rooted_dirt": "Karanistaja ziamla",
  "block.minecraft.rose_bush": "Ružovy kust",
  "block.minecraft.sand": "Piasok",
  "block.minecraft.sandstone": "Piasčanik",
  "block.minecraft.sandstone_slab": "Plita z piasčaniku",
  "block.minecraft.sandstone_stairs": "Prystupki z piasčaniku",
  "block.minecraft.sandstone_wall": "Sciana z piasčaniku",
  "block.minecraft.scaffolding": "Ryštavanni",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkavy katalizatar",
  "block.minecraft.sculk_sensor": "Sculkavy sensar",
  "block.minecraft.sculk_shrieker": "Sculkavy viskun",
  "block.minecraft.sculk_vein": "Sculkavaja žyła",
  "block.minecraft.sea_lantern": "Marski lichtar",
  "block.minecraft.sea_pickle": "Ahniaciełka",
  "block.minecraft.seagrass": "Marskaja trava",
  "block.minecraft.set_spawn": "Punkt adradžennia ŭstalavany",
  "block.minecraft.short_dry_grass": "Nizkaja suchaja trava",
  "block.minecraft.short_grass": "Nizkaja trava",
  "block.minecraft.shroomlight": "Sviatłahryb",
  "block.minecraft.shulker_box": "Shulkeravaja skrynia",
  "block.minecraft.skeleton_skull": "Čerap",
  "block.minecraft.skeleton_wall_skull": "Nascienny čerap",
  "block.minecraft.slime_block": "Błok slizi",
  "block.minecraft.small_amethyst_bud": "Maleńki zarodak amietystu",
  "block.minecraft.small_dripleaf": "Maleńki kroplalist",
  "block.minecraft.smithing_table": "Varštat kavala",
  "block.minecraft.smoker": "Viandlarnia",
  "block.minecraft.smooth_basalt": "Hładki bazalt",
  "block.minecraft.smooth_quartz": "Błok hładkaha kvarcu",
  "block.minecraft.smooth_quartz_slab": "Plita z hładkaha kvarcu",
  "block.minecraft.smooth_quartz_stairs": "Prystupki z hładkaha kvarcu",
  "block.minecraft.smooth_red_sandstone": "Hładki čyrvony piasčanik",
  "block.minecraft.smooth_red_sandstone_slab": "Plita z hładkaha čyrvonaha piasčaniku",
  "block.minecraft.smooth_red_sandstone_stairs": "Prystupki z hładkaha čyrvonaha piasčaniku",
  "block.minecraft.smooth_sandstone": "Hładki piasčanik",
  "block.minecraft.smooth_sandstone_slab": "Plita z hładkaha piasčaniku",
  "block.minecraft.smooth_sandstone_stairs": "Prystupki z hładkaha piasčaniku",
  "block.minecraft.smooth_stone": "Hładki kamień",
  "block.minecraft.smooth_stone_slab": "Plita z hładkaha kamienia",
  "block.minecraft.sniffer_egg": "Jajka niuchača",
  "block.minecraft.snow": "Snieh",
  "block.minecraft.snow_block": "Błok sniehu",
  "block.minecraft.soul_campfire": "Vohnišča duš",
  "block.minecraft.soul_fire": "Ahoń duš",
  "block.minecraft.soul_lantern": "Lichtar duš",
  "block.minecraft.soul_sand": "Piasok duš",
  "block.minecraft.soul_soil": "Hleba duš",
  "block.minecraft.soul_torch": "Fakieł duš",
  "block.minecraft.soul_wall_torch": "Nascienny fakieł duš",
  "block.minecraft.spawn.not_valid": "U vas niama łožka abo załadavanaj kotvy adradžennia, albo dostup da ich stračan",
  "block.minecraft.spawner": "Rassadnik pačvar",
  "block.minecraft.spawner.desc1": "Uzajemadziejanniaŭ z jajkam vykliku:",
  "block.minecraft.spawner.desc2": "Zadaje typ istoty",
  "block.minecraft.sponge": "Hubka",
  "block.minecraft.spore_blossom": "Kvietka sa sporami",
  "block.minecraft.spruce_button": "Jałovaja knopka",
  "block.minecraft.spruce_door": "Jałovyja dzviery",
  "block.minecraft.spruce_fence": "Jałovy płot",
  "block.minecraft.spruce_fence_gate": "Jałovaja bramka",
  "block.minecraft.spruce_hanging_sign": "Jałovaja padviesnaja šylda",
  "block.minecraft.spruce_leaves": "Ihlica",
  "block.minecraft.spruce_log": "Jałovaje bierviano",
  "block.minecraft.spruce_planks": "Jałovyja doški",
  "block.minecraft.spruce_pressure_plate": "Jałovaja nacisknaja plita",
  "block.minecraft.spruce_sapling": "Sadžaniec jełki",
  "block.minecraft.spruce_shelf": "Jałovaja palica",
  "block.minecraft.spruce_sign": "Jałovaja šylda",
  "block.minecraft.spruce_slab": "Jałovaja plita",
  "block.minecraft.spruce_stairs": "Jałovyja prystupki",
  "block.minecraft.spruce_trapdoor": "Jałovy luk",
  "block.minecraft.spruce_wall_hanging_sign": "Jałovaja nasciennaja padviesnaja šylda",
  "block.minecraft.spruce_wall_sign": "Jałovaja nasciennaja šylda",
  "block.minecraft.spruce_wood": "Jałovaja draŭnina",
  "block.minecraft.sticky_piston": "Lipki poršań",
  "block.minecraft.stone": "Kamień",
  "block.minecraft.stone_brick_slab": "Plita z kamiennaj cegły",
  "block.minecraft.stone_brick_stairs": "Prystupki z kamiennaj cegły",
  "block.minecraft.stone_brick_wall": "Sciana z kamiennaj cegły",
  "block.minecraft.stone_bricks": "Kamiennaja cegła",
  "block.minecraft.stone_button": "Kamiennaja knopka",
  "block.minecraft.stone_pressure_plate": "Kamiennaja nacisknaja plita",
  "block.minecraft.stone_slab": "Kamiennaja plita",
  "block.minecraft.stone_stairs": "Kamiennyja prystupki",
  "block.minecraft.stonecutter": "Kamieniarez",
  "block.minecraft.stripped_acacia_log": "Abčasanaje bierviano akacyi",
  "block.minecraft.stripped_acacia_wood": "Abčasanaja draŭnina akacyi",
  "block.minecraft.stripped_bamboo_block": "Błok abčasanaha bambuku",
  "block.minecraft.stripped_birch_log": "Abčasanaje biarozavaje bierviano",
  "block.minecraft.stripped_birch_wood": "Abčasanaja biarozavaja draŭnina",
  "block.minecraft.stripped_cherry_log": "Abčasanaje višniovaje bierviano",
  "block.minecraft.stripped_cherry_wood": "Abčasanaja višniovaja draŭnina",
  "block.minecraft.stripped_crimson_hyphae": "Abčasanyja barvovyja hify",
  "block.minecraft.stripped_crimson_stem": "Abčasanaje barvovaje sciabło",
  "block.minecraft.stripped_dark_oak_log": "Abčasanaje bierviano ciomnaha duba",
  "block.minecraft.stripped_dark_oak_wood": "Abčasanaja draŭnina ciomnaha duba",
  "block.minecraft.stripped_jungle_log": "Abčasanaje bierviano trapičnaha dreva",
  "block.minecraft.stripped_jungle_wood": "Abčasanaja trapičnaja draŭnina",
  "block.minecraft.stripped_mangrove_log": "Abčasanaje manhravaje bierviano",
  "block.minecraft.stripped_mangrove_wood": "Abčasanaja manhravaja draŭnina",
  "block.minecraft.stripped_oak_log": "Abčasanaje dubovaje bierviano",
  "block.minecraft.stripped_oak_wood": "Abčasanaja dubovaja draŭnina",
  "block.minecraft.stripped_pale_oak_log": "Abčasanaje bierviano blednaha duba",
  "block.minecraft.stripped_pale_oak_wood": "Abčasanaja draŭnina blednaha duba",
  "block.minecraft.stripped_spruce_log": "Abčasanaje jałovaje bierviano",
  "block.minecraft.stripped_spruce_wood": "Abčasanaja jałovaja draŭnina",
  "block.minecraft.stripped_warped_hyphae": "Abčasanyja skažonyja hify",
  "block.minecraft.stripped_warped_stem": "Abčasanaje skažonaje sciabło",
  "block.minecraft.structure_block": "Strukturny błok",
  "block.minecraft.structure_void": "Pustata",
  "block.minecraft.sugar_cane": "Cukrovy trysnioh",
  "block.minecraft.sunflower": "Słaniečnik",
  "block.minecraft.suspicious_gravel": "Padazrony žvir",
  "block.minecraft.suspicious_sand": "Padazrony piasok",
  "block.minecraft.sweet_berry_bush": "Kust sałodkich jahad",
  "block.minecraft.tall_dry_grass": "Vysokaja suchaja trava",
  "block.minecraft.tall_grass": "Vysokaja trava",
  "block.minecraft.tall_seagrass": "Vysokaja marskaja trava",
  "block.minecraft.target": "Mišeń",
  "block.minecraft.terracotta": "Kieramika",
  "block.minecraft.test_block": "Testavy błok",
  "block.minecraft.test_instance_block": "Błok testavaha asobnika",
  "block.minecraft.tinted_glass": "Taniravanaje škło",
  "block.minecraft.tnt": "Dynamit",
  "block.minecraft.tnt.disabled": "Vybuchi dynamitu adklučany",
  "block.minecraft.torch": "Fakieł",
  "block.minecraft.torchflower": "Pałymianaja lileja",
  "block.minecraft.torchflower_crop": "Parastak pałymianaj lilei",
  "block.minecraft.trapped_chest": "Kufar-pastka",
  "block.minecraft.trial_spawner": "Rassadnik vyprabavanniaŭ",
  "block.minecraft.tripwire": "Rasciažka",
  "block.minecraft.tripwire_hook": "Kruk",
  "block.minecraft.tube_coral": "Trubčasty karał",
  "block.minecraft.tube_coral_block": "Błok trubčastaha karała",
  "block.minecraft.tube_coral_fan": "Viejerny trubčasty karał",
  "block.minecraft.tube_coral_wall_fan": "Haryzantalny viejerny trubčasty karał",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Plita z tufavaj cegły",
  "block.minecraft.tuff_brick_stairs": "Prystupki z tufavaj cegły",
  "block.minecraft.tuff_brick_wall": "Sciana z tufavaj cegły",
  "block.minecraft.tuff_bricks": "Tufavaja cegła",
  "block.minecraft.tuff_slab": "Plita z tufu",
  "block.minecraft.tuff_stairs": "Prystupki z tufu",
  "block.minecraft.tuff_wall": "Sciana z tufu",
  "block.minecraft.turtle_egg": "Jajka čarapachi",
  "block.minecraft.twisting_vines": "Pakručastyja łozy",
  "block.minecraft.twisting_vines_plant": "Sciabło pakručastaj łazy",
  "block.minecraft.vault": "Skarbnica",
  "block.minecraft.verdant_froglight": "Małachitavaje žabinaje sviatło",
  "block.minecraft.vine": "Łaza",
  "block.minecraft.void_air": "Pustečnaje pavietra",
  "block.minecraft.wall_torch": "Nascienny fakieł",
  "block.minecraft.warped_button": "Skažonaja knopka",
  "block.minecraft.warped_door": "Skažonyja dzviery",
  "block.minecraft.warped_fence": "Skažony płot",
  "block.minecraft.warped_fence_gate": "Skažonaja bramka",
  "block.minecraft.warped_fungus": "Skažony hryb",
  "block.minecraft.warped_hanging_sign": "Skažonaja padviesnaja šylda",
  "block.minecraft.warped_hyphae": "Skažonyja hify",
  "block.minecraft.warped_nylium": "Skažony nilij",
  "block.minecraft.warped_planks": "Skažonyja doški",
  "block.minecraft.warped_pressure_plate": "Skažonaja nacisknaja plita",
  "block.minecraft.warped_roots": "Skažonyja karani",
  "block.minecraft.warped_shelf": "Skažonaja palica",
  "block.minecraft.warped_sign": "Skažonaja šylda",
  "block.minecraft.warped_slab": "Skažonaja plita",
  "block.minecraft.warped_stairs": "Skažonyja prystupki",
  "block.minecraft.warped_stem": "Skažonaje sciabło",
  "block.minecraft.warped_trapdoor": "Skažony luk",
  "block.minecraft.warped_wall_hanging_sign": "Skažonaja nasciennaja padviesnaja šylda",
  "block.minecraft.warped_wall_sign": "Skažonaja nasciennaja šylda",
  "block.minecraft.warped_wart_block": "Błok skažonaj netherskaj narasci",
  "block.minecraft.water": "Vada",
  "block.minecraft.water_cauldron": "Kacioł vady",
  "block.minecraft.waxed_chiseled_copper": "Vaskavanaja raźbianaja miedź",
  "block.minecraft.waxed_copper_bars": "Vaskavanyja miadzianyja kraty",
  "block.minecraft.waxed_copper_block": "Vaskavany miadziany błok",
  "block.minecraft.waxed_copper_bulb": "Vaskavanaja miadzianaja lampa",
  "block.minecraft.waxed_copper_chain": "Vaskavany miadziany łancuh",
  "block.minecraft.waxed_copper_chest": "Vaskavany miadziany kufar",
  "block.minecraft.waxed_copper_door": "Vaskavanyja miadzianyja dzviery",
  "block.minecraft.waxed_copper_golem_statue": "Vaskavanaja statuja miadzianaha holema",
  "block.minecraft.waxed_copper_grate": "Vaskavanaja miadzianaja rašotka",
  "block.minecraft.waxed_copper_lantern": "Vaskavany miadziany lichtar",
  "block.minecraft.waxed_copper_trapdoor": "Vaskavany miadziany luk",
  "block.minecraft.waxed_cut_copper": "Vaskavanaja raznaja miedź",
  "block.minecraft.waxed_cut_copper_slab": "Vaskavanaja plita z raznoj miedzi",
  "block.minecraft.waxed_cut_copper_stairs": "Vaskavanyja prystupki z raznoj miedzi",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vaskavanaja paćmianiełaja raźbianaja miedź",
  "block.minecraft.waxed_exposed_copper": "Vaskavanaja paćmianiełaja miedź",
  "block.minecraft.waxed_exposed_copper_bars": "Vaskavanyja paćmianiełyja miadzianyja kraty",
  "block.minecraft.waxed_exposed_copper_bulb": "Vaskavanaja paćmianiełaja miadzianaja lampa",
  "block.minecraft.waxed_exposed_copper_chain": "Vaskavany paćmianieły miadziany łancuh",
  "block.minecraft.waxed_exposed_copper_chest": "Vaskavany paćmianieły miadziany kufar",
  "block.minecraft.waxed_exposed_copper_door": "Vaskavanyja paćmianiełyja miadzianyja dzviery",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vaskavanaja paćmianiełaja statuja miadzianaha holema",
  "block.minecraft.waxed_exposed_copper_grate": "Vaskavanaja paćmianiełaja miadzianaja rašotka",
  "block.minecraft.waxed_exposed_copper_lantern": "Vaskavany paćmianieły miadziany lichtar",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vaskavany paćmianieły miadziany luk",
  "block.minecraft.waxed_exposed_cut_copper": "Vaskavanaja paćmianiełaja raznaja miedź",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Vaskavanaja paćmianiełaja plita z raznoj miedzi",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Vaskavanyja paćmianiełyja prystupki z raznoj miedzi",
  "block.minecraft.waxed_exposed_lightning_rod": "Vaskavany paćmianieły małankaadvod",
  "block.minecraft.waxed_lightning_rod": "Vaskavany małankaadvod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vaskavanaja akislenaja raźbianaja miedź",
  "block.minecraft.waxed_oxidized_copper": "Vaskavanaja akislenaja miedź",
  "block.minecraft.waxed_oxidized_copper_bars": "Vaskavanyja akislenyja miadzianyja kraty",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vaskavanaja akislenaja miadzianaja lampa",
  "block.minecraft.waxed_oxidized_copper_chain": "Vaskavany akisleny miadziany łancuh",
  "block.minecraft.waxed_oxidized_copper_chest": "Vaskavany akisleny miadziany kufar",
  "block.minecraft.waxed_oxidized_copper_door": "Vaskavanyja akislenyja miadzianyja dzviery",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vaskavanaja akislenaja statuja miadzianaha holema",
  "block.minecraft.waxed_oxidized_copper_grate": "Vaskavanaja akislenaja miadzianaja rašotka",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vaskavany akisleny miadziany lichtar",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vaskavany akisleny miadziany luk",
  "block.minecraft.waxed_oxidized_cut_copper": "Vaskavanaja akislenaja raznaja miedź",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Vaskavanaja akislenaja plita z raznoj miedzi",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Vaskavanyja akislenyja prystupki z raznoj miedzi",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vaskavany akisleny małankaadvod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vaskavanaja vyvietranaja raźbianaja miedź",
  "block.minecraft.waxed_weathered_copper": "Vaskavanaja vyvietranaja miedź",
  "block.minecraft.waxed_weathered_copper_bars": "Vaskavanyja vyvietranyja miadzianyja kraty",
  "block.minecraft.waxed_weathered_copper_bulb": "Vaskavanaja vyvietranaja miadzianaja lampa",
  "block.minecraft.waxed_weathered_copper_chain": "Vaskavany vyvietrany miadziany łancuh",
  "block.minecraft.waxed_weathered_copper_chest": "Vaskavany vyvietrany miadziany kufar",
  "block.minecraft.waxed_weathered_copper_door": "Vaskavanyja vyvietranyja miadzianyja dzviery",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vaskavanaja vyvietranaja statuja miadzianaha holema",
  "block.minecraft.waxed_weathered_copper_grate": "Vaskavanaja vyvietranaja miadzianaja rašotka",
  "block.minecraft.waxed_weathered_copper_lantern": "Vaskavany vyvietrany miadziany lichtar",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vaskavany vyvietrany miadziany luk",
  "block.minecraft.waxed_weathered_cut_copper": "Vaskavanaja vyvietranaja raznaja miedź",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Vaskavanaja vyvietranaja plita z raznoj miedzi",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Vaskavanyja vyvietranyja prystupki z raznoj miedzi",
  "block.minecraft.waxed_weathered_lightning_rod": "Vaskavany vyvietrany małankaadvod",
  "block.minecraft.weathered_chiseled_copper": "Vyvietranaja raźbianaja miedź",
  "block.minecraft.weathered_copper": "Vyvietranaja miedź",
  "block.minecraft.weathered_copper_bars": "Vyvietranyja miadzianyja kraty",
  "block.minecraft.weathered_copper_bulb": "Vyvietranaja miadzianaja lampa",
  "block.minecraft.weathered_copper_chain": "Vyvietrany miadziany łancuh",
  "block.minecraft.weathered_copper_chest": "Vyvietrany miadziany kufar",
  "block.minecraft.weathered_copper_door": "Vyvietranyja miadzianyja dzviery",
  "block.minecraft.weathered_copper_golem_statue": "Vyvietranaja statuja miadzianaha holema",
  "block.minecraft.weathered_copper_grate": "Vyvietranaja miadzianaja rašotka",
  "block.minecraft.weathered_copper_lantern": "Vyvietrany miadziany lichtar",
  "block.minecraft.weathered_copper_trapdoor": "Vyvietrany miadziany luk",
  "block.minecraft.weathered_cut_copper": "Vyvietranaja raznaja miedź",
  "block.minecraft.weathered_cut_copper_slab": "Plita z vyvietranaj raznoj miedzi",
  "block.minecraft.weathered_cut_copper_stairs": "Prystupki z vyvietranaj raznoj miedzi",
  "block.minecraft.weathered_lightning_rod": "Vyvietrany małankaadvod",
  "block.minecraft.weeping_vines": "Nicyja łozy",
  "block.minecraft.weeping_vines_plant": "Sciabło nicaj łazy",
  "block.minecraft.wet_sponge": "Mokraja hubka",
  "block.minecraft.wheat": "Parastki pšanicy",
  "block.minecraft.white_banner": "Bieły sciah",
  "block.minecraft.white_bed": "Bieły łožak",
  "block.minecraft.white_candle": "Biełaja sviečka",
  "block.minecraft.white_candle_cake": "Tort z biełaj sviečkaj",
  "block.minecraft.white_carpet": "Bieły dyvan",
  "block.minecraft.white_concrete": "Bieły bieton",
  "block.minecraft.white_concrete_powder": "Bieły cemient",
  "block.minecraft.white_glazed_terracotta": "Biełaja palivanaja kieramika",
  "block.minecraft.white_shulker_box": "Biełaja shulkeravaja skrynia",
  "block.minecraft.white_stained_glass": "Biełaje škło",
  "block.minecraft.white_stained_glass_pane": "Biełaja šyba",
  "block.minecraft.white_terracotta": "Biełaja kieramika",
  "block.minecraft.white_tulip": "Bieły ciulpan",
  "block.minecraft.white_wool": "Biełaja voŭna",
  "block.minecraft.wildflowers": "Palavyja kvietki",
  "block.minecraft.wither_rose": "Ruža withera",
  "block.minecraft.wither_skeleton_skull": "Čerap wither-škileta",
  "block.minecraft.wither_skeleton_wall_skull": "Nascienny čerap wither-škileta",
  "block.minecraft.yellow_banner": "Žoŭty sciah",
  "block.minecraft.yellow_bed": "Žoŭty łožak",
  "block.minecraft.yellow_candle": "Žoŭtaja sviečka",
  "block.minecraft.yellow_candle_cake": "Tort z žoŭtaj sviečkaj",
  "block.minecraft.yellow_carpet": "Žoŭty dyvan",
  "block.minecraft.yellow_concrete": "Žoŭty bieton",
  "block.minecraft.yellow_concrete_powder": "Žoŭty cemient",
  "block.minecraft.yellow_glazed_terracotta": "Žoŭtaja palivanaja kieramika",
  "block.minecraft.yellow_shulker_box": "Žoŭtaja shulkeravaja skrynia",
  "block.minecraft.yellow_stained_glass": "Žoŭtaje škło",
  "block.minecraft.yellow_stained_glass_pane": "Žoŭtaja šyba",
  "block.minecraft.yellow_terracotta": "Žoŭtaja kieramika",
  "block.minecraft.yellow_wool": "Žoŭtaja voŭna",
  "block.minecraft.zombie_head": "Hałava miercviaka",
  "block.minecraft.zombie_wall_head": "Nasciennaja hałava miercviaka",
  "item.minecraft.acacia_boat": "Čovien z akacyi",
  "item.minecraft.acacia_chest_boat": "Čovien z akacyi z kufram",
  "item.minecraft.allay_spawn_egg": "Jajka vykliku — Spakajoŭka",
  "item.minecraft.amethyst_shard": "Askołak amietystu",
  "item.minecraft.angler_pottery_shard": "Hančarny čarapok «Rybałoŭ»",
  "item.minecraft.angler_pottery_sherd": "Hančarny čarapok «Rybałoŭ»",
  "item.minecraft.apple": "Jabłyk",
  "item.minecraft.archer_pottery_shard": "Hančarny čarapok «Łučnik»",
  "item.minecraft.archer_pottery_sherd": "Hančarny čarapok «Łučnik»",
  "item.minecraft.armadillo_scute": "Łuskavinka branianosca",
  "item.minecraft.armadillo_spawn_egg": "Jajka vykliku — Branianosiec",
  "item.minecraft.armor_stand": "Stojka dla brani",
  "item.minecraft.arms_up_pottery_shard": "Hančarny čarapok «Ruki ŭhoru»",
  "item.minecraft.arms_up_pottery_sherd": "Hančarny čarapok «Ruki ŭhoru»",
  "item.minecraft.arrow": "Strała",
  "item.minecraft.axolotl_bucket": "Viadro z aksałotlem",
  "item.minecraft.axolotl_spawn_egg": "Jajka vykliku — Aksałotl",
  "item.minecraft.baked_potato": "Piečanaja bulba",
  "item.minecraft.bamboo_chest_raft": "Bambukavy płyt z kufram",
  "item.minecraft.bamboo_raft": "Bambukavy płyt",
  "item.minecraft.bat_spawn_egg": "Jajka vykliku — Kažan",
  "item.minecraft.bee_spawn_egg": "Jajka vykliku — Pčała",
  "item.minecraft.beef": "Syraja jałavičyna",
  "item.minecraft.beetroot": "Burak",
  "item.minecraft.beetroot_seeds": "Nasiennie buraka",
  "item.minecraft.beetroot_soup": "Boršč",
  "item.minecraft.birch_boat": "Biarozavy čovien",
  "item.minecraft.birch_chest_boat": "Biarozavy čovien z kufram",
  "item.minecraft.black_bundle": "Čorny miech",
  "item.minecraft.black_dye": "Čorny farbavalnik",
  "item.minecraft.black_harness": "Čornaja vupraž",
  "item.minecraft.blade_pottery_shard": "Hančarny čarapok «Lazo»",
  "item.minecraft.blade_pottery_sherd": "Hančarny čarapok «Lazo»",
  "item.minecraft.blaze_powder": "Vohnienny parašok",
  "item.minecraft.blaze_rod": "Vohnienny stryžań",
  "item.minecraft.blaze_spawn_egg": "Jajka vykliku — Połymień",
  "item.minecraft.blue_bundle": "Sini miech",
  "item.minecraft.blue_dye": "Sini farbavalnik",
  "item.minecraft.blue_egg": "Błakitnaja jajka",
  "item.minecraft.blue_harness": "Siniaja vupraž",
  "item.minecraft.bogged_spawn_egg": "Jajka vykliku — Dryhviak",
  "item.minecraft.bolt_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Arnamient «Nit»",
  "item.minecraft.bone": "Kosć",
  "item.minecraft.bone_meal": "Kasciavaja muka",
  "item.minecraft.book": "Kniha",
  "item.minecraft.bordure_indented_banner_pattern": "Šabłon sciaha «Zubčastaja lištva»",
  "item.minecraft.bow": "Łuk",
  "item.minecraft.bowl": "Miska",
  "item.minecraft.bread": "Chleb",
  "item.minecraft.breeze_rod": "Vietravy stryžań",
  "item.minecraft.breeze_spawn_egg": "Jajka vykliku — Vietryk",
  "item.minecraft.brewer_pottery_shard": "Hančarny čarapok «Ałchimik»",
  "item.minecraft.brewer_pottery_sherd": "Hančarny čarapok «Ałchimik»",
  "item.minecraft.brewing_stand": "Varačnaja stojka",
  "item.minecraft.brick": "Caglina",
  "item.minecraft.brown_bundle": "Karyčnievy miech",
  "item.minecraft.brown_dye": "Karyčnievy farbavalnik",
  "item.minecraft.brown_egg": "Karyčnievaje jajka",
  "item.minecraft.brown_harness": "Karyčnievaja vupraž",
  "item.minecraft.brush": "Pendzal",
  "item.minecraft.bucket": "Viadro",
  "item.minecraft.bundle": "Miech",
  "item.minecraft.bundle.empty": "Pusty",
  "item.minecraft.bundle.empty.description": "Moža miascić stos roznych pradmietaŭ",
  "item.minecraft.bundle.full": "Poŭny",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Hančarny čarapok «Połymia»",
  "item.minecraft.burn_pottery_sherd": "Hančarny čarapok «Połymia»",
  "item.minecraft.camel_husk_spawn_egg": "Jajka vykliku — Viarblud-zdychlak",
  "item.minecraft.camel_spawn_egg": "Jajka vykliku — Viarblud",
  "item.minecraft.carrot": "Morkva",
  "item.minecraft.carrot_on_a_stick": "Morkva na pałačcy",
  "item.minecraft.cat_spawn_egg": "Jajka vykliku — Kot",
  "item.minecraft.cauldron": "Kacioł",
  "item.minecraft.cave_spider_spawn_egg": "Jajka vykliku — Piačorny pavuk",
  "item.minecraft.chainmail_boots": "Kalčužnyja boty",
  "item.minecraft.chainmail_chestplate": "Kalčužny nahrudnik",
  "item.minecraft.chainmail_helmet": "Kalčužny šlem",
  "item.minecraft.chainmail_leggings": "Kalčužnyja ponažy",
  "item.minecraft.charcoal": "Draŭniany vuhal",
  "item.minecraft.cherry_boat": "Čovien z višniovaj draŭniny",
  "item.minecraft.cherry_chest_boat": "Čovien z višniovaj draŭniny z kufram",
  "item.minecraft.chest_minecart": "Vahanietka z kufram",
  "item.minecraft.chicken": "Syraja kuracina",
  "item.minecraft.chicken_spawn_egg": "Jajka vykliku — Kuryca",
  "item.minecraft.chorus_fruit": "Płod chorusu",
  "item.minecraft.clay_ball": "Kamiak hliny",
  "item.minecraft.clock": "Hadzinnik",
  "item.minecraft.coal": "Vuhal",
  "item.minecraft.coast_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Arnamient «Uzbiarežža»",
  "item.minecraft.cocoa_beans": "Kakava-baby",
  "item.minecraft.cod": "Syraja traska",
  "item.minecraft.cod_bucket": "Viadro z traskoj",
  "item.minecraft.cod_spawn_egg": "Jajka vykliku — Traska",
  "item.minecraft.command_block_minecart": "Vahanietka z kamandnym błokam",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Smažanaja jałavičyna",
  "item.minecraft.cooked_chicken": "Smažanaja kuracina",
  "item.minecraft.cooked_cod": "Smažanaja traska",
  "item.minecraft.cooked_mutton": "Smažanaja baranina",
  "item.minecraft.cooked_porkchop": "Smažanaja svinina",
  "item.minecraft.cooked_rabbit": "Smažanaja trusiacina",
  "item.minecraft.cooked_salmon": "Smažany łasoś",
  "item.minecraft.cookie": "Piečyva",
  "item.minecraft.copper_axe": "Miadzianaja siakiera",
  "item.minecraft.copper_boots": "Miadzianyja boty",
  "item.minecraft.copper_chestplate": "Miadzianaja kirasa",
  "item.minecraft.copper_golem_spawn_egg": "Jajka vykliku — Miadziany holem",
  "item.minecraft.copper_helmet": "Miadziany šlem",
  "item.minecraft.copper_hoe": "Miadzianaja matyka",
  "item.minecraft.copper_horse_armor": "Miadzianaja konskaja brania",
  "item.minecraft.copper_ingot": "Miadziany zlitak",
  "item.minecraft.copper_leggings": "Miadzianyja ponažy",
  "item.minecraft.copper_nautilus_armor": "Miadzianaja naŭtyłusava brania",
  "item.minecraft.copper_nugget": "Kavałak miedzi",
  "item.minecraft.copper_pickaxe": "Miadzianaja kirka",
  "item.minecraft.copper_shovel": "Miadzianaja rydloŭka",
  "item.minecraft.copper_spear": "Miadzianaja dzida",
  "item.minecraft.copper_sword": "Miadziany mieč",
  "item.minecraft.cow_spawn_egg": "Jajka vykliku — Karova",
  "item.minecraft.creaking_spawn_egg": "Jajka vykliku — Rypień",
  "item.minecraft.creeper_banner_pattern": "Šabłon sciaha",
  "item.minecraft.creeper_banner_pattern.desc": "Tvar creepera",
  "item.minecraft.creeper_banner_pattern.new": "Šabłon sciaha «Creeper»",
  "item.minecraft.creeper_spawn_egg": "Jajka vykliku — Creeper",
  "item.minecraft.crossbow": "Samastreł",
  "item.minecraft.crossbow.projectile": "Snarad:",
  "item.minecraft.crossbow.projectile.multiple": "Snarad: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Snarad: %s",
  "item.minecraft.cyan_bundle": "Biruzovy miech",
  "item.minecraft.cyan_dye": "Biruzovy farbavalnik",
  "item.minecraft.cyan_harness": "Biruzovaja vupraž",
  "item.minecraft.danger_pottery_shard": "Hančarny čarapok «Pahroza»",
  "item.minecraft.danger_pottery_sherd": "Hančarny čarapok «Pahroza»",
  "item.minecraft.dark_oak_boat": "Čovien z ciomnaha dubu",
  "item.minecraft.dark_oak_chest_boat": "Čovien z ciomnaha dubu z kufram",
  "item.minecraft.debug_stick": "Pałačka adładki",
  "item.minecraft.debug_stick.empty": "U %s niama ŭłascivasciaŭ",
  "item.minecraft.debug_stick.select": "vybrana «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s» u %s",
  "item.minecraft.diamond": "Dyjamient",
  "item.minecraft.diamond_axe": "Dyjamientavaja siakiera",
  "item.minecraft.diamond_boots": "Dyjamientavyja boty",
  "item.minecraft.diamond_chestplate": "Dyjamientavaja kirasa",
  "item.minecraft.diamond_helmet": "Dyjamientavy šlem",
  "item.minecraft.diamond_hoe": "Dyjamientavaja matyka",
  "item.minecraft.diamond_horse_armor": "Dyjamientavaja konskaja brania",
  "item.minecraft.diamond_leggings": "Dyjamientavyja ponažy",
  "item.minecraft.diamond_nautilus_armor": "Dyjamientavaja naŭtyłusava brania",
  "item.minecraft.diamond_pickaxe": "Dyjamientavaja kirka",
  "item.minecraft.diamond_shovel": "Dyjamientavaja rydloŭka",
  "item.minecraft.diamond_spear": "Dyjamientavaja dzida",
  "item.minecraft.diamond_sword": "Dyjamientavy mieč",
  "item.minecraft.disc_fragment_5": "Frahmient hrampłascinki",
  "item.minecraft.disc_fragment_5.desc": "Hrampłascinka — 5",
  "item.minecraft.dolphin_spawn_egg": "Jajka vykliku — Delfin",
  "item.minecraft.donkey_spawn_egg": "Jajka vykliku — Asioł",
  "item.minecraft.dragon_breath": "Dychannie cmoka",
  "item.minecraft.dried_kelp": "Sušanaja łaminaryja",
  "item.minecraft.drowned_spawn_egg": "Jajka vykliku — Tapielec",
  "item.minecraft.dune_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Arnamient «Vydma»",
  "item.minecraft.echo_shard": "Askołak recha",
  "item.minecraft.egg": "Jajka",
  "item.minecraft.elder_guardian_spawn_egg": "Jajka vykliku — Staražytny vartavy",
  "item.minecraft.elytra": "Elitry",
  "item.minecraft.emerald": "Smarahd",
  "item.minecraft.enchanted_book": "Začaravanaja kniha",
  "item.minecraft.enchanted_golden_apple": "Začaravany załaty jabłyk",
  "item.minecraft.end_crystal": "Kryštal Enda",
  "item.minecraft.ender_dragon_spawn_egg": "Jajka vykliku — Ender-cmok",
  "item.minecraft.ender_eye": "Voka Endera",
  "item.minecraft.ender_pearl": "Žamčužyna Enda",
  "item.minecraft.enderman_spawn_egg": "Jajka vykliku — Enderman",
  "item.minecraft.endermite_spawn_egg": "Jajka vykliku — Endermite",
  "item.minecraft.evoker_spawn_egg": "Jajka vykliku — Zaklinalnik",
  "item.minecraft.experience_bottle": "Plaška dosviedu",
  "item.minecraft.explorer_pottery_shard": "Hančarny čarapok «Dasledčyk»",
  "item.minecraft.explorer_pottery_sherd": "Hančarny čarapok «Dasledčyk»",
  "item.minecraft.eye_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Arnamient «Voka»",
  "item.minecraft.feather": "Piaro",
  "item.minecraft.fermented_spider_eye": "Marynavanaje pavučynaje voka",
  "item.minecraft.field_masoned_banner_pattern": "Šabłon sciaha «Mur»",
  "item.minecraft.filled_map": "Karta",
  "item.minecraft.fire_charge": "Vohnienny šar",
  "item.minecraft.firework_rocket": "Fiejervierk",
  "item.minecraft.firework_rocket.flight": "Praciahłasć palotu:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Naboj fiejervierku",
  "item.minecraft.firework_star.black": "Čorny",
  "item.minecraft.firework_star.blue": "Sini",
  "item.minecraft.firework_star.brown": "Karyčnievy",
  "item.minecraft.firework_star.custom_color": "Karystalnicki",
  "item.minecraft.firework_star.cyan": "Biruzovy",
  "item.minecraft.firework_star.fade_to": "Pierachodzić u",
  "item.minecraft.firework_star.flicker": "Milhaciennie",
  "item.minecraft.firework_star.gray": "Šery",
  "item.minecraft.firework_star.green": "Zialony",
  "item.minecraft.firework_star.light_blue": "Błakitny",
  "item.minecraft.firework_star.light_gray": "Svietła-šery",
  "item.minecraft.firework_star.lime": "Łajmavy",
  "item.minecraft.firework_star.magenta": "Purpurny",
  "item.minecraft.firework_star.orange": "Aranžavy",
  "item.minecraft.firework_star.pink": "Ružovy",
  "item.minecraft.firework_star.purple": "Fijaletavy",
  "item.minecraft.firework_star.red": "Čyrvony",
  "item.minecraft.firework_star.shape": "Nieviadomaja forma",
  "item.minecraft.firework_star.shape.burst": "Vybuch",
  "item.minecraft.firework_star.shape.creeper": "Creeperapadobny",
  "item.minecraft.firework_star.shape.large_ball": "Vialiki šar",
  "item.minecraft.firework_star.shape.small_ball": "Maleńki šar",
  "item.minecraft.firework_star.shape.star": "Zorkapadobny",
  "item.minecraft.firework_star.trail": "Sled",
  "item.minecraft.firework_star.white": "Bieły",
  "item.minecraft.firework_star.yellow": "Žoŭty",
  "item.minecraft.fishing_rod": "Vuda",
  "item.minecraft.flint": "Kremień",
  "item.minecraft.flint_and_steel": "Kresiva",
  "item.minecraft.flow_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Arnamient «Płyń»",
  "item.minecraft.flow_banner_pattern": "Šabłon sciaha",
  "item.minecraft.flow_banner_pattern.desc": "Płyń",
  "item.minecraft.flow_banner_pattern.new": "Šabłon sciaha «Płyń»",
  "item.minecraft.flow_pottery_sherd": "Hančarny čarapok «Płyń»",
  "item.minecraft.flower_banner_pattern": "Šabłon sciaha",
  "item.minecraft.flower_banner_pattern.desc": "Kvietka",
  "item.minecraft.flower_banner_pattern.new": "Šabłon sciaha «Kvietka»",
  "item.minecraft.flower_pot": "Harščok",
  "item.minecraft.fox_spawn_egg": "Jajka vykliku — Lis",
  "item.minecraft.friend_pottery_shard": "Hančarny čarapok «Siabar»",
  "item.minecraft.friend_pottery_sherd": "Hančarny čarapok «Siabar»",
  "item.minecraft.frog_spawn_egg": "Jajka vykliku — Žaba",
  "item.minecraft.furnace_minecart": "Vahanietka z piečču",
  "item.minecraft.ghast_spawn_egg": "Jajka vykliku — Ghast",
  "item.minecraft.ghast_tear": "Slaza ghasta",
  "item.minecraft.glass_bottle": "Šklanaja plaška",
  "item.minecraft.glistering_melon_slice": "Zichatlivy kavałak kavuna",
  "item.minecraft.globe_banner_pattern": "Šabłon sciaha",
  "item.minecraft.globe_banner_pattern.desc": "Hłobus",
  "item.minecraft.globe_banner_pattern.new": "Šabłon sciaha «Hłobus»",
  "item.minecraft.glow_berries": "Zichatlivyja jahady",
  "item.minecraft.glow_ink_sac": "Zichatlivy čarnilny miašok",
  "item.minecraft.glow_item_frame": "Zichatlivaja ramka",
  "item.minecraft.glow_squid_spawn_egg": "Jajka vykliku — Zichatlivy sprut",
  "item.minecraft.glowstone_dust": "Zichatlivy pył",
  "item.minecraft.goat_horn": "Kaziny roh",
  "item.minecraft.goat_spawn_egg": "Jajka vykliku — Kaza",
  "item.minecraft.gold_ingot": "Załaty zlitak",
  "item.minecraft.gold_nugget": "Kavałak zołata",
  "item.minecraft.golden_apple": "Załaty jabłyk",
  "item.minecraft.golden_axe": "Załataja siakiera",
  "item.minecraft.golden_boots": "Załatyja boty",
  "item.minecraft.golden_carrot": "Załataja morkva",
  "item.minecraft.golden_chestplate": "Załataja kirasa",
  "item.minecraft.golden_helmet": "Załaty šlem",
  "item.minecraft.golden_hoe": "Załataja matyka",
  "item.minecraft.golden_horse_armor": "Załataja konskaja brania",
  "item.minecraft.golden_leggings": "Załatyja ponažy",
  "item.minecraft.golden_nautilus_armor": "Załataja naŭtyłusava brania",
  "item.minecraft.golden_pickaxe": "Załataja kirka",
  "item.minecraft.golden_shovel": "Załataja rydloŭka",
  "item.minecraft.golden_spear": "Załataja dzida",
  "item.minecraft.golden_sword": "Załaty mieč",
  "item.minecraft.gray_bundle": "Šery miech",
  "item.minecraft.gray_dye": "Šery farbavalnik",
  "item.minecraft.gray_harness": "Šeraja vupraž",
  "item.minecraft.green_bundle": "Zialony miech",
  "item.minecraft.green_dye": "Zialony farbavalnik",
  "item.minecraft.green_harness": "Zialonaja vupraž",
  "item.minecraft.guardian_spawn_egg": "Jajka vykliku — Vartavy",
  "item.minecraft.gunpowder": "Porach",
  "item.minecraft.guster_banner_pattern": "Šabłon sciaha",
  "item.minecraft.guster_banner_pattern.desc": "Paryŭ",
  "item.minecraft.guster_banner_pattern.new": "Šabłon sciaha «Paryŭ»",
  "item.minecraft.guster_pottery_sherd": "Hančarny čarapok «Paryŭ»",
  "item.minecraft.happy_ghast_spawn_egg": "Jajka vykliku — Ščaslivy ghast",
  "item.minecraft.harness": "Vupraž",
  "item.minecraft.heart_of_the_sea": "Serca mora",
  "item.minecraft.heart_pottery_shard": "Hančarny čarapok «Serca»",
  "item.minecraft.heart_pottery_sherd": "Hančarny čarapok «Serca»",
  "item.minecraft.heartbreak_pottery_shard": "Hančarny čarapok «Razbitaje serca»",
  "item.minecraft.heartbreak_pottery_sherd": "Hančarny čarapok «Razbitaje serca»",
  "item.minecraft.hoglin_spawn_egg": "Jajka vykliku — Hoglin",
  "item.minecraft.honey_bottle": "Plaška miodu",
  "item.minecraft.honeycomb": "Soty",
  "item.minecraft.hopper_minecart": "Vahanietka z varonkaj",
  "item.minecraft.horse_spawn_egg": "Jajka vykliku — Koń",
  "item.minecraft.host_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.host_armor_trim_smithing_template.new": "Arnamient «Haspadar»",
  "item.minecraft.howl_pottery_shard": "Hančarny čarapok «Vyccio»",
  "item.minecraft.howl_pottery_sherd": "Hančarny čarapok «Vyccio»",
  "item.minecraft.husk_spawn_egg": "Jajka vykliku — Zdychlak",
  "item.minecraft.ink_sac": "Čarnilny miašok",
  "item.minecraft.iron_axe": "Žaleznaja siakiera",
  "item.minecraft.iron_boots": "Žaleznyja boty",
  "item.minecraft.iron_chestplate": "Žaleznaja kirasa",
  "item.minecraft.iron_golem_spawn_egg": "Jajka vykliku — Žalezny holem",
  "item.minecraft.iron_helmet": "Žalezny šlem",
  "item.minecraft.iron_hoe": "Žaleznaja matyka",
  "item.minecraft.iron_horse_armor": "Žaleznaja konskaja brania",
  "item.minecraft.iron_ingot": "Žalezny zlitak",
  "item.minecraft.iron_leggings": "Žaleznyja ponažy",
  "item.minecraft.iron_nautilus_armor": "Žaleznaja naŭtyłusava brania",
  "item.minecraft.iron_nugget": "Kavałak žaleza",
  "item.minecraft.iron_pickaxe": "Žaleznaja kirka",
  "item.minecraft.iron_shovel": "Žaleznaja rydloŭka",
  "item.minecraft.iron_spear": "Žaleznaja dzida",
  "item.minecraft.iron_sword": "Žalezny mieč",
  "item.minecraft.item_frame": "Ramka",
  "item.minecraft.jungle_boat": "Čovien z trapičnaj draŭniny",
  "item.minecraft.jungle_chest_boat": "Čovien z trapičnaj draŭniny z kufram",
  "item.minecraft.knowledge_book": "Kniha viedaŭ",
  "item.minecraft.lapis_lazuli": "Łazuryt",
  "item.minecraft.lava_bucket": "Viadro łavy",
  "item.minecraft.lead": "Pavadok",
  "item.minecraft.leather": "Skura",
  "item.minecraft.leather_boots": "Skuranyja boty",
  "item.minecraft.leather_chestplate": "Skuranaja kurtka",
  "item.minecraft.leather_helmet": "Skuranaja šapka",
  "item.minecraft.leather_horse_armor": "Skuranaja konskaja brania",
  "item.minecraft.leather_leggings": "Skuranyja nahavicy",
  "item.minecraft.light_blue_bundle": "Błakitny miech",
  "item.minecraft.light_blue_dye": "Błakitny farbavalnik",
  "item.minecraft.light_blue_harness": "Błakitnaja vupraž",
  "item.minecraft.light_gray_bundle": "Svietła-šery miech",
  "item.minecraft.light_gray_dye": "Svietła-šery farbavalnik",
  "item.minecraft.light_gray_harness": "Svietła-šeraja vupraž",
  "item.minecraft.lime_bundle": "Łajmavy miech",
  "item.minecraft.lime_dye": "Łajmavy farbavalnik",
  "item.minecraft.lime_harness": "Łajmavaja vupraž",
  "item.minecraft.lingering_potion": "Tryvałaje zielle",
  "item.minecraft.lingering_potion.effect.awkward": "Niazhrabnaje tryvałaje zielle",
  "item.minecraft.lingering_potion.effect.empty": "Tryvałaje niestvaralnaje zielle",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Tryvałaje zielle vohnieŭstojlivasci",
  "item.minecraft.lingering_potion.effect.harming": "Tryvałaje zielle škody",
  "item.minecraft.lingering_potion.effect.healing": "Tryvałaje zielle hajennia",
  "item.minecraft.lingering_potion.effect.infested": "Tryvałaje zielle zaražennia",
  "item.minecraft.lingering_potion.effect.invisibility": "Tryvałaje zielle niabačnasci",
  "item.minecraft.lingering_potion.effect.leaping": "Tryvałaje zielle skakučasci",
  "item.minecraft.lingering_potion.effect.levitation": "Tryvałaje zielle levitacyi",
  "item.minecraft.lingering_potion.effect.luck": "Tryvałaje zielle ŭdačy",
  "item.minecraft.lingering_potion.effect.mundane": "Zvyčajnaje tryvałaje zielle",
  "item.minecraft.lingering_potion.effect.night_vision": "Tryvałaje zielle načnoha zroku",
  "item.minecraft.lingering_potion.effect.oozing": "Tryvałaje zielle aslizłasci",
  "item.minecraft.lingering_potion.effect.poison": "Tryvałaje atrutnaje zielle",
  "item.minecraft.lingering_potion.effect.regeneration": "Tryvałaje zielle rehienieracyi",
  "item.minecraft.lingering_potion.effect.slow_falling": "Tryvałaje zielle pavolnaha padziennia",
  "item.minecraft.lingering_potion.effect.slowness": "Tryvałaje zielle zapavolennia",
  "item.minecraft.lingering_potion.effect.strength": "Tryvałaje zielle mocy",
  "item.minecraft.lingering_potion.effect.swiftness": "Tryvałaje zielle chutkasci",
  "item.minecraft.lingering_potion.effect.thick": "Hustoje tryvałaje zielle",
  "item.minecraft.lingering_potion.effect.turtle_master": "Tryvałaje zielle čarapašaj mocy",
  "item.minecraft.lingering_potion.effect.water": "Tryvałaja plaška vady",
  "item.minecraft.lingering_potion.effect.water_breathing": "Tryvałaje zielle padvodnaha dychannia",
  "item.minecraft.lingering_potion.effect.weakness": "Tryvałaje zielle kvołasci",
  "item.minecraft.lingering_potion.effect.weaving": "Tryvałaje zielle placiennia",
  "item.minecraft.lingering_potion.effect.wind_charged": "Tryvałaje zielle vietranasci",
  "item.minecraft.llama_spawn_egg": "Jajka vykliku — Łama",
  "item.minecraft.lodestone_compass": "Namahničany kompas",
  "item.minecraft.mace": "Bułava",
  "item.minecraft.magenta_bundle": "Purpurny miech",
  "item.minecraft.magenta_dye": "Purpurny farbavalnik",
  "item.minecraft.magenta_harness": "Purpurnaja vupraž",
  "item.minecraft.magma_cream": "Zhustak mahmy",
  "item.minecraft.magma_cube_spawn_egg": "Jajka vykliku — Mahmakub",
  "item.minecraft.mangrove_boat": "Čovien z manhravaj draŭniny",
  "item.minecraft.mangrove_chest_boat": "Čovien z manhravaj draŭniny z kufram",
  "item.minecraft.map": "Pustaja karta",
  "item.minecraft.melon_seeds": "Nasiennie kavuna",
  "item.minecraft.melon_slice": "Kavałak kavuna",
  "item.minecraft.milk_bucket": "Viadro małaka",
  "item.minecraft.minecart": "Vahanietka",
  "item.minecraft.miner_pottery_shard": "Hančarny čarapok «Šachcior»",
  "item.minecraft.miner_pottery_sherd": "Hančarny čarapok «Šachcior»",
  "item.minecraft.mojang_banner_pattern": "Šabłon sciaha",
  "item.minecraft.mojang_banner_pattern.desc": "Štości",
  "item.minecraft.mojang_banner_pattern.new": "Šabłon sciaha «Štości»",
  "item.minecraft.mooshroom_spawn_egg": "Jajka vykliku — Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Hančarny čarapok «Smutkoŭca»",
  "item.minecraft.mourner_pottery_sherd": "Hančarny čarapok «Smutkoŭca»",
  "item.minecraft.mule_spawn_egg": "Jajka vykliku — Muł",
  "item.minecraft.mushroom_stew": "Tušanyja hryby",
  "item.minecraft.music_disc_11": "Hrampłascinka",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Hrampłascinka",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Hrampłascinka",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg — 5",
  "item.minecraft.music_disc_blocks": "Hrampłascinka",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Hrampłascinka",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Hrampłascinka",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Hrampłascinka",
  "item.minecraft.music_disc_creator.desc": "Lena Raine — Creator",
  "item.minecraft.music_disc_creator_music_box": "Hrampłascinka",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine — Creator (Music Box)",
  "item.minecraft.music_disc_far": "Hrampłascinka",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Hrampłascinka",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Hrampłascinka",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Hrampłascinka",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Hrampłascinka",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine — otherside",
  "item.minecraft.music_disc_pigstep": "Hrampłascinka",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine — Pigstep",
  "item.minecraft.music_disc_precipice": "Hrampłascinka",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof — Precipice",
  "item.minecraft.music_disc_relic": "Hrampłascinka",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof — Relic",
  "item.minecraft.music_disc_stal": "Hrampłascinka",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Hrampłascinka",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Hrampłascinka",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy — Tears",
  "item.minecraft.music_disc_wait": "Hrampłascinka",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Hrampłascinka",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Syraja baranina",
  "item.minecraft.name_tag": "Birka",
  "item.minecraft.nautilus_shell": "Rakavina naŭtyłusa",
  "item.minecraft.nautilus_spawn_egg": "Jajka vykliku — Naŭtyłus",
  "item.minecraft.nether_brick": "Netherskaja caglina",
  "item.minecraft.nether_star": "Zorka Nethera",
  "item.minecraft.nether_wart": "Netherskaja narasć",
  "item.minecraft.netherite_axe": "Netherytavaja siakiera",
  "item.minecraft.netherite_boots": "Netherytavyja boty",
  "item.minecraft.netherite_chestplate": "Netherytavaja kirasa",
  "item.minecraft.netherite_helmet": "Netherytavy šlem",
  "item.minecraft.netherite_hoe": "Netherytavaja matyka",
  "item.minecraft.netherite_horse_armor": "Netherytavaja konskaja brania",
  "item.minecraft.netherite_ingot": "Netherytavy zlitak",
  "item.minecraft.netherite_leggings": "Netherytavyja ponažy",
  "item.minecraft.netherite_nautilus_armor": "Netherytavaja naŭtyłusava brania",
  "item.minecraft.netherite_pickaxe": "Netherytavaja kirka",
  "item.minecraft.netherite_scrap": "Netherytavy abłomak",
  "item.minecraft.netherite_shovel": "Netherytavaja rydloŭka",
  "item.minecraft.netherite_spear": "Netherytavaja dzida",
  "item.minecraft.netherite_sword": "Netherytavy mieč",
  "item.minecraft.netherite_upgrade_smithing_template": "Kavalski šabłon",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritavaje palapšennie",
  "item.minecraft.oak_boat": "Dubovy čovien",
  "item.minecraft.oak_chest_boat": "Dubovy čovien z kufram",
  "item.minecraft.ocelot_spawn_egg": "Jajka vykliku — Acełot",
  "item.minecraft.ominous_bottle": "Złaviesnaja plaška",
  "item.minecraft.ominous_trial_key": "Złaviesny kluč vyprabavanniaŭ",
  "item.minecraft.orange_bundle": "Aranžavy miech",
  "item.minecraft.orange_dye": "Aranžavy farbavalnik",
  "item.minecraft.orange_harness": "Aranžavaja vupraž",
  "item.minecraft.painting": "Karcina",
  "item.minecraft.pale_oak_boat": "Čovien z blednaha dubu",
  "item.minecraft.pale_oak_chest_boat": "Čovien z blednaha dubu z kufram",
  "item.minecraft.panda_spawn_egg": "Jajka vykliku — Panda",
  "item.minecraft.paper": "Papiera",
  "item.minecraft.parched_spawn_egg": "Jajka vykliku — Suchlak",
  "item.minecraft.parrot_spawn_egg": "Jajka vykliku — Papuhaj",
  "item.minecraft.phantom_membrane": "Miembrana fantoma",
  "item.minecraft.phantom_spawn_egg": "Jajka vykliku — Fantom",
  "item.minecraft.pig_spawn_egg": "Jajka vykliku — Svinnia",
  "item.minecraft.piglin_banner_pattern": "Šabłon sciaha",
  "item.minecraft.piglin_banner_pattern.desc": "Łyč",
  "item.minecraft.piglin_banner_pattern.new": "Šabłon sciaha «Łyč»",
  "item.minecraft.piglin_brute_spawn_egg": "Jajka vykliku — Brutalny piglin",
  "item.minecraft.piglin_spawn_egg": "Jajka vykliku — Piglin",
  "item.minecraft.pillager_spawn_egg": "Jajka vykliku — Maradzior",
  "item.minecraft.pink_bundle": "Ružovy miech",
  "item.minecraft.pink_dye": "Ružovy farbavalnik",
  "item.minecraft.pink_harness": "Ružovaja vupraž",
  "item.minecraft.pitcher_plant": "Hładyšnik",
  "item.minecraft.pitcher_pod": "Pušačka hładyšnika",
  "item.minecraft.plenty_pottery_shard": "Hančarny čarapok «Bahaccie»",
  "item.minecraft.plenty_pottery_sherd": "Hančarny čarapok «Bahaccie»",
  "item.minecraft.poisonous_potato": "Atrutnaja bulba",
  "item.minecraft.polar_bear_spawn_egg": "Jajka vykliku — Bieły miadzviedź",
  "item.minecraft.popped_chorus_fruit": "Piečany płod chorusu",
  "item.minecraft.porkchop": "Syraja svinina",
  "item.minecraft.potato": "Bulba",
  "item.minecraft.potion": "Zielle",
  "item.minecraft.potion.effect.awkward": "Niazhrabnaje zielle",
  "item.minecraft.potion.effect.empty": "Niestvaralnaje zielle",
  "item.minecraft.potion.effect.fire_resistance": "Zielle vohnieŭstojlivasci",
  "item.minecraft.potion.effect.harming": "Zielle škody",
  "item.minecraft.potion.effect.healing": "Zielle hajennia",
  "item.minecraft.potion.effect.infested": "Zielle zaražennia",
  "item.minecraft.potion.effect.invisibility": "Zielle niabačnasci",
  "item.minecraft.potion.effect.leaping": "Zielle skakučasci",
  "item.minecraft.potion.effect.levitation": "Zielle levitacyi",
  "item.minecraft.potion.effect.luck": "Zielle ŭdačy",
  "item.minecraft.potion.effect.mundane": "Zvyčajnaje zielle",
  "item.minecraft.potion.effect.night_vision": "Zielle načnoha zroku",
  "item.minecraft.potion.effect.oozing": "Zielle aslizłasci",
  "item.minecraft.potion.effect.poison": "Atrutnaje zielle",
  "item.minecraft.potion.effect.regeneration": "Zielle rehienieracyi",
  "item.minecraft.potion.effect.slow_falling": "Zielle pavolnaha padziennia",
  "item.minecraft.potion.effect.slowness": "Zielle zapavolennia",
  "item.minecraft.potion.effect.strength": "Zielle mocy",
  "item.minecraft.potion.effect.swiftness": "Zielle chutkasci",
  "item.minecraft.potion.effect.thick": "Hustoje zielle",
  "item.minecraft.potion.effect.turtle_master": "Zielle čarapašaj mocy",
  "item.minecraft.potion.effect.water": "Plaška vady",
  "item.minecraft.potion.effect.water_breathing": "Zielle padvodnaha dychannia",
  "item.minecraft.potion.effect.weakness": "Zielle kvołasci",
  "item.minecraft.potion.effect.weaving": "Zielle placiennia",
  "item.minecraft.potion.effect.wind_charged": "Zielle vietranasci",
  "item.minecraft.pottery_shard_archer": "Hančarny čarapok «Łučnik»",
  "item.minecraft.pottery_shard_arms_up": "Hančarny čarapok «Ruki ŭhoru»",
  "item.minecraft.pottery_shard_prize": "Hančarny čarapok «Uznaharoda»",
  "item.minecraft.pottery_shard_skull": "Hančarny čarapok «Čerap»",
  "item.minecraft.powder_snow_bucket": "Viadro sypkaha sniehu",
  "item.minecraft.prismarine_crystals": "Pryzmarynavyja kryštali",
  "item.minecraft.prismarine_shard": "Pryzmarynavy askiepak",
  "item.minecraft.prize_pottery_shard": "Hančarny čarapok «Uznaharoda»",
  "item.minecraft.prize_pottery_sherd": "Hančarny čarapok «Uznaharoda»",
  "item.minecraft.pufferfish": "Ihołkabruch",
  "item.minecraft.pufferfish_bucket": "Viadro z ihołkabrucham",
  "item.minecraft.pufferfish_spawn_egg": "Jajka vykliku — Ihołkabruch",
  "item.minecraft.pumpkin_pie": "Harbuzovy piroh",
  "item.minecraft.pumpkin_seeds": "Nasiennie harbuza",
  "item.minecraft.purple_bundle": "Fijaletavy miech",
  "item.minecraft.purple_dye": "Fijaletavy farbavalnik",
  "item.minecraft.purple_harness": "Fijaletavaja vupraž",
  "item.minecraft.quartz": "Kvarc",
  "item.minecraft.rabbit": "Syraja trusiacina",
  "item.minecraft.rabbit_foot": "Łapka trusa",
  "item.minecraft.rabbit_hide": "Škura trusa",
  "item.minecraft.rabbit_spawn_egg": "Jajka vykliku — Trus",
  "item.minecraft.rabbit_stew": "Tušany trus",
  "item.minecraft.raiser_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Arnamient «Hadoŭca»",
  "item.minecraft.ravager_spawn_egg": "Jajka vykliku — Spustašalnik",
  "item.minecraft.raw_copper": "Syraja miedź",
  "item.minecraft.raw_gold": "Syroje zołata",
  "item.minecraft.raw_iron": "Syroje žaleza",
  "item.minecraft.recovery_compass": "Kompas viartannia",
  "item.minecraft.red_bundle": "Čyrvony miech",
  "item.minecraft.red_dye": "Čyrvony farbavalnik",
  "item.minecraft.red_harness": "Čyrvonaja vupraž",
  "item.minecraft.redstone": "Redstonavy pył",
  "item.minecraft.resin_brick": "Smalanaja caglina",
  "item.minecraft.resin_clump": "Zhustak smały",
  "item.minecraft.rib_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Arnamient «Rabro»",
  "item.minecraft.rotten_flesh": "Hniłoje miasa",
  "item.minecraft.saddle": "Siadło",
  "item.minecraft.salmon": "Syry łasoś",
  "item.minecraft.salmon_bucket": "Viadro z łasosiem",
  "item.minecraft.salmon_spawn_egg": "Jajka vykliku — Łasoś",
  "item.minecraft.scrape_pottery_sherd": "Hančarny čarapok «Skrabiennie»",
  "item.minecraft.scute": "Łuskavinka",
  "item.minecraft.sentry_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Arnamient «Varta»",
  "item.minecraft.shaper_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Arnamient «Skulptar»",
  "item.minecraft.sheaf_pottery_shard": "Hančarny čarapok «Snop»",
  "item.minecraft.sheaf_pottery_sherd": "Hančarny čarapok «Snop»",
  "item.minecraft.shears": "Nažnicy",
  "item.minecraft.sheep_spawn_egg": "Jajka vykliku — Aviečka",
  "item.minecraft.shelter_pottery_shard": "Hančarny čarapok «Prytułak»",
  "item.minecraft.shelter_pottery_sherd": "Hančarny čarapok «Prytułak»",
  "item.minecraft.shield": "Ščyt",
  "item.minecraft.shield.black": "Čorny ščyt",
  "item.minecraft.shield.blue": "Sini ščyt",
  "item.minecraft.shield.brown": "Karyčnievy ščyt",
  "item.minecraft.shield.cyan": "Biruzovy ščyt",
  "item.minecraft.shield.gray": "Šery ščyt",
  "item.minecraft.shield.green": "Zialony ščyt",
  "item.minecraft.shield.light_blue": "Błakitny ščyt",
  "item.minecraft.shield.light_gray": "Svietła-šery ščyt",
  "item.minecraft.shield.lime": "Łajmavy ščyt",
  "item.minecraft.shield.magenta": "Purpurny ščyt",
  "item.minecraft.shield.orange": "Aranžavy ščyt",
  "item.minecraft.shield.pink": "Ružovy ščyt",
  "item.minecraft.shield.purple": "Fijaletavy ščyt",
  "item.minecraft.shield.red": "Čyrvony ščyt",
  "item.minecraft.shield.white": "Bieły ščyt",
  "item.minecraft.shield.yellow": "Žoŭty ščyt",
  "item.minecraft.shulker_shell": "Pancyr shulkera",
  "item.minecraft.shulker_spawn_egg": "Jajka vykliku — Shulker",
  "item.minecraft.sign": "Šylda",
  "item.minecraft.silence_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Arnamient «Cišynia»",
  "item.minecraft.silverfish_spawn_egg": "Jajka vykliku — Łuskaŭnica",
  "item.minecraft.skeleton_horse_spawn_egg": "Jajka vykliku — Koń-škilet",
  "item.minecraft.skeleton_spawn_egg": "Jajka vykliku — Škilet",
  "item.minecraft.skull_banner_pattern": "Šabłon sciaha",
  "item.minecraft.skull_banner_pattern.desc": "Čerap",
  "item.minecraft.skull_banner_pattern.new": "Šabłon sciaha «Čerap»",
  "item.minecraft.skull_pottery_shard": "Hančarny čarapok «Čerap»",
  "item.minecraft.skull_pottery_sherd": "Hančarny čarapok «Čerap»",
  "item.minecraft.slime_ball": "Zhustak slizi",
  "item.minecraft.slime_spawn_egg": "Jajka vykliku — Slimak",
  "item.minecraft.smithing_template": "Kavalski šabłon",
  "item.minecraft.smithing_template.applies_to": "Možna prymianić da:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Zmiascicie siudy zlitak abo kryštal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Brania",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Zmiascicie siudy elemient brani",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Zlitki i kryštali",
  "item.minecraft.smithing_template.ingredients": "Inhredyjenty:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Zmiascicie siudy netherytavy zlitak",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Dyjamientavyja pryłady",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Zmiascicie siudy dyjamientavuju braniu, zbroju ci instrumient",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherytavy zlitak",
  "item.minecraft.smithing_template.upgrade": "Palapšennie: ",
  "item.minecraft.sniffer_spawn_egg": "Jajka vykliku — Niuchač",
  "item.minecraft.snort_pottery_shard": "Hančarny čarapok «Niuchač»",
  "item.minecraft.snort_pottery_sherd": "Hančarny čarapok «Niuchač»",
  "item.minecraft.snout_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Arnamient «Łyč»",
  "item.minecraft.snow_golem_spawn_egg": "Jajka vykliku — Sniežny holem",
  "item.minecraft.snowball": "Sniežka",
  "item.minecraft.spectral_arrow": "Spiektralnaja strała",
  "item.minecraft.spider_eye": "Pavučynaje voka",
  "item.minecraft.spider_spawn_egg": "Jajka vykliku — Pavuk",
  "item.minecraft.spire_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Arnamient «Vieža»",
  "item.minecraft.splash_potion": "Vybuchovaje zielle",
  "item.minecraft.splash_potion.effect.awkward": "Niazhrabnaje vybuchovaje zielle",
  "item.minecraft.splash_potion.effect.empty": "Vybuchnoje niestvaralnaje zielle",
  "item.minecraft.splash_potion.effect.fire_resistance": "Vybuchnoje zielle vohnieŭstojlivasci",
  "item.minecraft.splash_potion.effect.harming": "Vybuchnoje zielle škody",
  "item.minecraft.splash_potion.effect.healing": "Vybuchnoje zielle hajennia",
  "item.minecraft.splash_potion.effect.infested": "Vybuchnoje zielle zaražennia",
  "item.minecraft.splash_potion.effect.invisibility": "Vybuchnoje zielle niabačnasci",
  "item.minecraft.splash_potion.effect.leaping": "Vybuchnoje zielle skakučasci",
  "item.minecraft.splash_potion.effect.levitation": "Vybuchnoje zielle levitacyi",
  "item.minecraft.splash_potion.effect.luck": "Vybuchnoje zielle ŭdačy",
  "item.minecraft.splash_potion.effect.mundane": "Zvyčajnaje vybuchnoje zielle",
  "item.minecraft.splash_potion.effect.night_vision": "Vybuchnoje zielle načnoha zroku",
  "item.minecraft.splash_potion.effect.oozing": "Vybuchnoje zielle aslizłasci",
  "item.minecraft.splash_potion.effect.poison": "Vybuchnoje atrutnaje zielle",
  "item.minecraft.splash_potion.effect.regeneration": "Vybuchnoje zielle rehienieracyi",
  "item.minecraft.splash_potion.effect.slow_falling": "Vybuchnoje zielle pavolnaha padziennia",
  "item.minecraft.splash_potion.effect.slowness": "Vybuchnoje zielle zapavolennia",
  "item.minecraft.splash_potion.effect.strength": "Vybuchnoje zielle mocy",
  "item.minecraft.splash_potion.effect.swiftness": "Vybuchnoje zielle chutkasci",
  "item.minecraft.splash_potion.effect.thick": "Hustoje vybuchnoje zielle",
  "item.minecraft.splash_potion.effect.turtle_master": "Vybuchnoje zielle čarapašaj mocy",
  "item.minecraft.splash_potion.effect.water": "Vybuchnaja plaška vady",
  "item.minecraft.splash_potion.effect.water_breathing": "Vybuchnoje zielle padvodnaha dychannia",
  "item.minecraft.splash_potion.effect.weakness": "Vybuchnoje zielle kvołasci",
  "item.minecraft.splash_potion.effect.weaving": "Vybuchnoje zielle placiennia",
  "item.minecraft.splash_potion.effect.wind_charged": "Vybuchnoje zielle vietranasci",
  "item.minecraft.spruce_boat": "Jałovy čovien",
  "item.minecraft.spruce_chest_boat": "Jałovy čovien z kufram",
  "item.minecraft.spyglass": "Padzornaja truba",
  "item.minecraft.squid_spawn_egg": "Jajka vykliku — Sprut",
  "item.minecraft.stick": "Pałka",
  "item.minecraft.stone_axe": "Kamiennaja siakiera",
  "item.minecraft.stone_hoe": "Kamiennaja matyka",
  "item.minecraft.stone_pickaxe": "Kamiennaja kirka",
  "item.minecraft.stone_shovel": "Kamiennaja rydloŭka",
  "item.minecraft.stone_spear": "Kamiennaja dzida",
  "item.minecraft.stone_sword": "Kamienny mieč",
  "item.minecraft.stray_spawn_egg": "Jajka vykliku — Badziaha",
  "item.minecraft.strider_spawn_egg": "Jajka vykliku — Łavacuha",
  "item.minecraft.string": "Nitka",
  "item.minecraft.sugar": "Cukar",
  "item.minecraft.suspicious_stew": "Padazronaje rahu",
  "item.minecraft.sweet_berries": "Sałodkija jahady",
  "item.minecraft.tadpole_bucket": "Viadro z apałonikam",
  "item.minecraft.tadpole_spawn_egg": "Jajka vykliku — Apałonik",
  "item.minecraft.tide_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Arnamient «Chvali»",
  "item.minecraft.tipped_arrow": "Apracavanaja strała",
  "item.minecraft.tipped_arrow.effect.awkward": "Apracavanaja strała",
  "item.minecraft.tipped_arrow.effect.empty": "Niestvarajemaja apracavanaja strała",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Strała vohnieŭstojlivasci",
  "item.minecraft.tipped_arrow.effect.harming": "Strała škody",
  "item.minecraft.tipped_arrow.effect.healing": "Hajučaja strała",
  "item.minecraft.tipped_arrow.effect.infested": "Strała zaražennia",
  "item.minecraft.tipped_arrow.effect.invisibility": "Strała niabačnasci",
  "item.minecraft.tipped_arrow.effect.leaping": "Strała skakučasci",
  "item.minecraft.tipped_arrow.effect.levitation": "Strała levitacyi",
  "item.minecraft.tipped_arrow.effect.luck": "Strała ŭdačy",
  "item.minecraft.tipped_arrow.effect.mundane": "Apracavanaja strała",
  "item.minecraft.tipped_arrow.effect.night_vision": "Strała načnoha zroku",
  "item.minecraft.tipped_arrow.effect.oozing": "Strała aslizłasci",
  "item.minecraft.tipped_arrow.effect.poison": "Atručanaja strała",
  "item.minecraft.tipped_arrow.effect.regeneration": "Strała rehienieracyi",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Strała pavolnaha padziennia",
  "item.minecraft.tipped_arrow.effect.slowness": "Strała zapavolennia",
  "item.minecraft.tipped_arrow.effect.strength": "Strała mocy",
  "item.minecraft.tipped_arrow.effect.swiftness": "Strała chutkasci",
  "item.minecraft.tipped_arrow.effect.thick": "Apracavanaja strała",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Strała čarapašaj mocy",
  "item.minecraft.tipped_arrow.effect.water": "Vybuchnaja strała",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Strała vodnaha dychannia",
  "item.minecraft.tipped_arrow.effect.weakness": "Strała kvołasci",
  "item.minecraft.tipped_arrow.effect.weaving": "Strała placiennia",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Strała vietranasci",
  "item.minecraft.tnt_minecart": "Vahanietka z dynamitam",
  "item.minecraft.torchflower_seeds": "Nasiennie pałymianaj lilei",
  "item.minecraft.totem_of_undying": "Tatem biassmiercia",
  "item.minecraft.trader_llama_spawn_egg": "Jajka vykliku — Łama handlara",
  "item.minecraft.trial_key": "Kluč vyprabavanniaŭ",
  "item.minecraft.trident": "Tryzubiec",
  "item.minecraft.tropical_fish": "Trapičnaja ryba",
  "item.minecraft.tropical_fish_bucket": "Viadro z trapičnaj rybaj",
  "item.minecraft.tropical_fish_spawn_egg": "Jajka vykliku — Trapičnaja ryba",
  "item.minecraft.turtle_helmet": "Pancyr čarapachi",
  "item.minecraft.turtle_scute": "Łuskavinka čarapachi",
  "item.minecraft.turtle_spawn_egg": "Jajka vykliku — Čarapacha",
  "item.minecraft.vex_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Arnamient «Škodnik»",
  "item.minecraft.vex_spawn_egg": "Jajka vykliku — Škodnik",
  "item.minecraft.villager_spawn_egg": "Jajka vykliku — Viaskoviec",
  "item.minecraft.vindicator_spawn_egg": "Jajka vykliku — Baraćbit",
  "item.minecraft.wandering_trader_spawn_egg": "Jajka vykliku — Vandroŭny handlar",
  "item.minecraft.ward_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Arnamient «Vartaŭnik»",
  "item.minecraft.warden_spawn_egg": "Jajka vykliku — Vartaŭnik",
  "item.minecraft.warped_fungus_on_a_stick": "Skažony hryb na pałačcy",
  "item.minecraft.water_bucket": "Viadro vady",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Arnamient «Pieršaprachodziec»",
  "item.minecraft.wheat": "Pšanica",
  "item.minecraft.wheat_seeds": "Nasiennie pšanicy",
  "item.minecraft.white_bundle": "Bieły miech",
  "item.minecraft.white_dye": "Bieły farbavalnik",
  "item.minecraft.white_harness": "Biełaja vupraž",
  "item.minecraft.wild_armor_trim_smithing_template": "Kavalski šabłon",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Arnamient «Džunhli»",
  "item.minecraft.wind_charge": "Zarad vietru",
  "item.minecraft.witch_spawn_egg": "Jajka vykliku — Viedźma",
  "item.minecraft.wither_skeleton_spawn_egg": "Jajka vykliku — Wither-škilet",
  "item.minecraft.wither_spawn_egg": "Jajka vykliku — Wither",
  "item.minecraft.wolf_armor": "Voŭčaja brania",
  "item.minecraft.wolf_spawn_egg": "Jajka vykliku — Voŭk",
  "item.minecraft.wooden_axe": "Draŭlanaja siakiera",
  "item.minecraft.wooden_hoe": "Draŭlanaja matyka",
  "item.minecraft.wooden_pickaxe": "Draŭlanaja kirka",
  "item.minecraft.wooden_shovel": "Draŭlanaja rydloŭka",
  "item.minecraft.wooden_spear": "Draŭlanaja dzida",
  "item.minecraft.wooden_sword": "Draŭlany mieč",
  "item.minecraft.writable_book": "Kniha i piaro",
  "item.minecraft.written_book": "Napisanaja kniha",
  "item.minecraft.yellow_bundle": "Žoŭty miech",
  "item.minecraft.yellow_dye": "Žoŭty farbavalnik",
  "item.minecraft.yellow_harness": "Žoŭtaja vupraž",
  "item.minecraft.zoglin_spawn_egg": "Jajka vykliku — Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Jajka vykliku — Koń-miarcviak",
  "item.minecraft.zombie_nautilus_spawn_egg": "Jajka vykliku — Naŭtyłus-miarcviak",
  "item.minecraft.zombie_spawn_egg": "Jajka vykliku — Miarcviak",
  "item.minecraft.zombie_villager_spawn_egg": "Jajka vykliku — Miarcviak-viaskoviec",
  "item.minecraft.zombified_piglin_spawn_egg": "Jajka vykliku — Miarcviak-piglin"
}
export const be_latn = items; 
